import type { zh } from "./zh";

/** English. Typed against the Chinese table: a key missing here is a compile error. */
export const en: Record<keyof typeof zh, string> = {
  "nav.label": "Main navigation",
  "nav.overview": "Overview",
  "nav.jobs": "Jobs",
  "nav.companies": "Companies",
  "nav.interviews": "Interviews",
  "nav.me": "My profile",
  "nav.agent": "Agent",
  "nav.collapse": "Collapse",
  "nav.expand": "Expand",
  "nav.loading": "loading...",
  "nav.cardFailed": "Could not open the card. Please try again.",
  "nav.areaFailed": "Could not load this. Please try again.",
  "nav.offline": "You're offline. Reconnect and try again.",
  "nav.slow": "Still loading, slower than usual...",
  "nav.failed": "Something went wrong with the page. Please try again.",
  "nav.dismiss": "Dismiss",
  "theme.toDark": "Switch to night",
  "theme.toLight": "Switch to day",
  "lang.label": "Language",
  "help.label": "Help & contact",
  "help.lede": "Something not working, or an idea? Write to us:",
  "help.copy": "Copy",
  "help.copied": "Copied",
  "help.copyByHand": "Could not copy it; the address is selected, copy it by hand.",
  "auth.support": "Trouble? Write to",
  "fold.open": "Open →",

  "chat.new": "New conversation",
  "chat.expand": "Expand conversation",
  "chat.min": "Hide",
  "chat.dock": "Dock to the right",
  "chat.undock": "Undock (back to floating)",
  "chat.dockNarrow": "Dock to the right (needs a wider screen)",
  "chat.resizeW": "Conversation width",
  "chat.resizeH": "Conversation height",
  "chat.end": "End and note what I learned",
  "chat.endMock": "End the interview and hear the verdict",
  "chat.endAsk": "End this session? I’ll note what we covered in your profile — it takes ten seconds or so. Talking again starts a new session.",
  "chat.endAskMock": "End this mock interview? The interviewer will write a verdict — it takes ten seconds or so.",
  "chat.cancel": "Cancel",
  "chat.endOk": "End",
  "chat.title": "New thread",
  "chat.sub": "Ask anytime",
  "chat.opener": "Anything I can help with? Where do you want to start?",
  "chat.placeholder": "Ask something…",
  "chat.send": "Send",
  "chat.attach": "Attach",
  "chat.attachKinds": "Attach a PDF, a Word, Excel or PowerPoint file, a .txt or .md, or an image",
  "chat.attachFailed": "That file did not upload.",
  "chat.hereIsFile": "Have a look at this.",
  "chat.afterActions": "I’ve noted the above. Reply and I’ll carry on.",
  "chat.cutCeiling": "That answer ran too long and was cut off. Reply “continue” and I’ll pick up where it stopped.",
  "chat.cutStopped": "That answer was stopped partway through. Try asking another way.",
  "chat.drop": "Drop to attach",
  "chat.remove": "Remove",
  "chat.cvSaved": "Saved as your CV: %1",
  "chat.tailorProposed": "Changes proposed: %1 (expansions: %2)",
  "chat.tailorDecided": "Accepted: %1 (expansions: %2), rejected: %3",
  "chat.cvReplaced": "Saved as your CV: %1, replacing %2",
  "chat.cvReread": "Reading your CV again: %1",
  "chat.tooMany": "At most %1 files at a time",
  "modal.close": "Close",
  "modal.cancel": "Cancel",
  "modal.gone": "This one is gone.",
  "thread.mock": "Mock · %1",
  "thread.tailor": "CV · %1",
  "thread.interview": "Interview · %1",
  "thread.profile": "Profile",
  "thread.criteria": "Criteria",
  "thread.draft": "Drafting · %1 · %2",
  "thread.draftLoose": "Drafting · %1",
  "thread.free": "New thread",
  "thread.untitled.opening": "An opening",
  "thread.untitled.company": "An employer",
  "thread.untitled.interview": "An interview",
  "thread.untitled.mock": "A mock interview",
  "thread.untitled.tailor": "A CV rewrite",
  "thread.channel.whatsapp": "WhatsApp",
  "thread.channel.slack": "Slack",
  "thread.channel.telegram": "Telegram",
  "chan.endWord": "end session",
  "chan.endHint": "(Send “end session” to end this session.)",
  "chan.ended": "Session ended.",
  "chan.endedIdle": "This session ended because there was no further reply.",
  "chan.nothingToEnd": "There is no session in progress.",
  "chan.wrote": "Noted: %1",
  "chan.learned": "%1 rule(s) wait for your confirmation on the site: %2",
  "chan.unknown": "This chat is not connected to an account. Connect it under Me → Settings: %1",
  "chan.many": "This chat is connected to more than one account; keep it on one in Settings first.",
  "chan.off": "Chat is not switched on here. Turn it on in Settings: %1",
  "chan.trialOver": "Your free week is over; see the site: %1",
  "chan.failed": "That one could not be answered; send it again in a moment.",
  "chan.badFile": "That file could not be taken: %1",
  "chan.onlyThese": "Only text, PDFs and images are read.",
  "me.set.ch.chat": "Chat",
  "me.set.ch.chatHint": "When on, messages from here are answered by the agent; send “end session” to close a session.",
  "chan.slack.noFiles": "Send files on the site or in WhatsApp; only text is read here.",
  "me.set.ch.wa.lede": "Once connected you can chat with the agent in WhatsApp (pushes are not wired yet); connecting is sending a code from your phone.",
  "me.set.ch.wa.connect": "Connect WhatsApp",
  "me.set.ch.wa.unavailable": "This deployment has no WhatsApp number yet; nothing to connect to.",
  "me.set.ch.tg.lede": "Pushes arrive in Telegram with buttons: answer each opening of the morning on the spot (apply / save / not for me), and reply to a question to answer it; you can also chat with the agent there. Connecting is pressing Start once in Telegram.",
  "me.set.ch.tg.connect": "Connect Telegram",
  "me.set.ch.tg.open": "Press Start in Telegram",
  "me.set.ch.tg.valid": "Good for another %1 minutes; reload this page once you have pressed Start.",
  "me.set.ch.tg.unavailable": "This deployment has no Telegram bot yet; nothing to connect to.",
  "me.set.ch.tg.connected": "Your Telegram",
  "me.set.ch.wa.open": "Send the code in WhatsApp",
  "me.set.ch.wa.code": "Or send this code to the number above: %1",
  "me.set.ch.wa.valid": "Good for another %1 minutes; reload this page once it is sent.",
  "chan.wa.linked": "Connected: this number now belongs to the account %1 and can chat with the agent; send “end session” to close a session.",
  "chan.wa.expired": "That connection code has expired or was already used. Go back to Me → Settings and press “Connect WhatsApp” again.",
  "chan.wa.conflict": "This phone number already belongs to another Counting AI account and cannot be transferred. Sign in to that account or recover it with its email.",
  "chan.tg.linked": "Connected: this Telegram now belongs to the account %1. The morning and questions come here, and you can chat with the agent; send “end session” to close a session. Choose what is pushed under Me → Settings.",
  "chan.tg.expired": "That connection code has expired or was already used. Go back to Me → Settings and press “Connect Telegram” again.",
  "chan.tg.conflict": "This Telegram is already connected to another Counting AI account and cannot be moved. Remove it in that account's settings first, then connect it here.",
  "chan.tg.hello": "This is Counting AI's pushes. To connect, press “Connect Telegram” under Me → Settings: %1",

  "kind.all": "All",
  "kind.opening": "Jobs",
  "kind.company": "Companies",
  "kind.interview": "Interviews",
  "kind.mock": "Mocks",
  "kind.tailor": "CV",
  "kind.meta": "Profile · rules",
  "kind.profile": "Profile",
  "kind.criteria": "Criteria",
  "kind.free": "Thread",
  "agent.search": "Search threads…",
  "agent.newThread": "+ New thread",
  "agent.today": "Today",
  "agent.week": "This week",
  "agent.earlier": "Earlier",
  "agent.none": "No matching threads",
  "agent.pick": "Pick a thread, or start a new one.",
  "agent.unread": "New reply",
  "agent.open.opening": "Open this job →",
  "agent.open.company": "Open company card →",
  "agent.open.interview": "Open interview prep →",
  "agent.open.profile": "Open profile →",
  "agent.open.criteria": "Open criteria →",
  "agent.mockPlaceholder": "Answer in English… (say ‘in Chinese’ to switch the round, ‘end’ for a summary)",
  "agent.folded": "Previous %1 turns folded into a summary · expand",
  "agent.ended": "Session ended %1",
  "agent.endedNothing": "Nothing to write down this time.",
  "agent.more": "%1 earlier messages",
  "agent.loading": "Loading…",
  "agent.thinking": "Thinking…",
  "agent.looking": "Reading:",
  "agent.failed": "That did not go through. Try again?",
  "agent.endFailed": "Could not end the session; try once more.",
  "agent.ending": "Ending the session, noting what we covered in your profile…",
  "agent.endingMock": "The interviewer is writing the verdict…",
  "agent.capped": "Showing the latest 100; search finds older ones.",
  "opener.opening": "%1 · %2%3",
  "opener.askThis": "Ask about this one",
  "opener.notNow": "Not now",
  "opener.company": "%1 · matching open roles: %2 · visa: %3",
  "opener.askCompany": "Worth following?",
  "opener.interview": "%1 of 4 preparation pieces ready.",
  "opener.missing": "Missing: %1.",
  "opener.askPress": "Go over the points they will press",
  "opener.mock": "Mock interview, %1 of 4 pieces prepared. Say “start” and I ask the first question.",
  "opener.tailor": "Tailoring your CV for “%1”. Say “start” and I'll go through the requirements and what the two simulated screeners made of your CV, then propose changes line by line.",
  "opener.tailorKept": "This rewrite for “%1” was made on an earlier CV of yours and is kept as it was: you can read its final version and download it. To work on it, start a new rewrite for this posting on the page.",
  "opener.start": "Start",
  "opener.profile": "What you say about yourself here goes into your profile.",
  "opener.criteria": "Rules changed here apply from the next run.",
  "opener.rules": "A few rules await your confirmation.",
  "opener.pending": "A few things still need you.",
  "prep.deep": "Research",
  "action.confirm.learned.yes": "Keep this rule",
  "action.confirm.learned.no": "Drop it",
  "action.confirm.before": "Answered earlier; nothing changed",

  "status.maybe": "saved",
  "status.passed": "passed",
  "status.preparing": "queued",
  "status.applied": "applied",
  "status.interview_requested": "interview invited",
  "status.interviewing": "interviewing",
  "status.offer": "offer",
  "status.rejected": "rejected",

  "level.high": "High match",
  "level.mid": "Mid match",
  "level.low": "Low match",
  "level.unrated": "Unrated",

  "flag.visa": "Visa",
  "flag.lang": "Language",
  "flag.move": "Place",
  "flag.salary": "Pay",
  "basis.stated": "stated",
  "basis.inferred": "inferred",
  "basis.unknown": "not stated",
  "card.flagNone": "The posting doesn't mention it.",
  "visa.stated_yes": "will sponsor",
  "visa.likely": "likely sponsors",
  "visa.unknown": "unknown",
  "visa.stated_no": "no sponsorship",
  "local.none": "no language you lack",
  "local.plus": "local language a plus",
  "local.required": "needs a language you lack",
  "local.unknown": "not stated",
  "move.no_move": "no move",
  "move.remote_home": "remote in-country",
  "move.in_country": "in your country",
  "move.move_home": "move in-country",
  "move.remote_abroad": "remote abroad",
  "move.move_abroad": "move abroad",
  "move.unknown": "not stated",
  "pay.clears_threshold": "above floor",
  "pay.below_threshold": "below floor",
  "pay.not_stated": "not published",
  "mode.remote": "remote",
  "mode.hybrid": "hybrid",
  "mode.onsite": "on site",
  "mode.unclear": "not stated",

  "card.original": "Original ↗",
  "card.undo": "Undo",
  "card.why": "Why you",
  "card.concerns": "My concerns",
  "card.goApply": "Go and apply",
  "card.goApplyArrow": "Go and apply →",
  "card.save": "Save for later",
  "card.notFor": "Not for me",
  "card.tailor": "Tailor my CV to this job",
  "card.tailorOthers": "Other rewrites",
  "card.tailorEdited": "Last edited: %1",
  "card.tailorStale": "on an earlier CV",
  "card.tailorView": "View the tailored CV",
  "card.tailoredFold": "Tailored CV",
  "tailor.title": "Tailor CV",
  "tailor.back": "← Back to the job",
  "tailor.return": "← Back",
  "tailor.backAgent": "← Agent",
  "tailor.strength.nudge": "Strength: rewording only",
  "tailor.strength.keywords": "Strength: the posting's own words",
  "tailor.strength.full": "Strength: full rewrite",
  "tailor.all": "Accept all (%1)",
  "tailor.allExpansions": "Accept all (%1; expansions: %2)",
  "tailor.none": "No changes yet. Say “start” in the conversation: the requirements are read first, then changes come one by one, each for you to accept or reject.",
  "tailor.accept": "Accept",
  "tailor.reject": "Reject",
  "tailor.withdraw": "Withdraw",
  "tailor.reaccept": "Accept after all",
  "tailor.working.accept": "Accepting…",
  "tailor.working.reject": "Rejecting…",
  "tailor.working.withdraw": "Withdrawing…",
  "tailor.working.reaccept": "Accepting…",
  "tailor.working.all": "Accepting all…",
  "tailor.state.proposed": "Waiting",
  "tailor.state.accepted": "Accepted",
  "tailor.state.rejected": "Rejected",
  "tailor.expansion": "Expansion",
  "tailor.expansionWhy": "The CV does not say this; make sure it is true before accepting.",
  "tailor.src.resume": "Source: CV %1",
  "tailor.src.said": "Source: said in the conversation on %1: “%2”",
  "tailor.src.none": "Source: not in the CV",
  "tailor.serves": "For requirement %1",
  "tailor.flag.term": "New name: %1",
  "tailor.flag.number": "New figure: %1",
  "tailor.flag.year": "New year: %1",
  "tailor.flag.authorship": "Someone else's work written as your own: %1",
  "tailor.flag.cited": "Draws on another position's lines",
  "tailor.flag.said": "These words are not in the conversation",
  "tailor.flag.skills": "Removes skills",
  "tailor.flag.long": "Much longer than the line",
  "tailor.act.replace": "Changed",
  "tailor.act.add": "Added",
  "tailor.act.remove": "Removed",
  "tailor.act.move": "Moved after %1",
  "tailor.fact": "Fact line (employer, title, dates): not rewritten",
  "tailor.section.summary": "Summary",
  "tailor.section.experience": "Experience",
  "tailor.section.education": "Education",
  "tailor.section.skills": "Skills",
  "tailor.section.publications": "Publications",
  "tailor.section.other": "Other",
  "tailor.view.merged": "Merged",
  "tailor.view.split": "Side by side",
  "tailor.was": "Before",
  "tailor.now": "After",
  "tailor.reqs": "Requirement by requirement",
  "tailor.reqsNote": "Two simulated screeners each judge, requirement by requirement, whether the CV shows it. No total score.",
  "tailor.reqsNone": "The requirements have not been read yet. Say “start” in the conversation.",
  "tailor.before": "Before",
  "tailor.after": "After",
  "tailor.screener": "Screener %1",
  "tailor.recheck": "Check again",
  "tailor.checking": "Checking again…",
  "tailor.checkFailed": "The check failed. Please try again.",
  "tailor.notYet": "Not checked",
  "tailor.must": "Must",
  "tailor.nice": "Nice to have",
  "tailor.verdict.evidence": "Shown",
  "tailor.verdict.weak": "Mentioned",
  "tailor.verdict.none": "Missing",
  "tailor.verdict.unknown": "No answer",
  "tailor.stale": "This rewrite was made on an earlier CV of yours. Below is its final version as it was, which you can download. To work on it with the CV you have now, start again.",
  "tailor.noOutline": "The CV has to be read once more before it can be shown here line by line.",
  "tailor.pdfNote": "Your CV on record is a PDF: an export is laid out anew in a one-column layout, not like the original. A Word original is edited in place.",
  "tailor.posting": "The posting",
  "tailor.sr.gone": "Removed: ",
  "tailor.sr.new": "Added: ",
  "tailor.aria.accept": "Accept the change to %1",
  "tailor.aria.reject": "Reject the change to %1",
  "tailor.aria.withdraw": "Withdraw the change to %1",
  "tailor.aria.reaccept": "Accept the change to %1 after all",
  "tailor.restart": "Start a new rewrite for this job",
  "tailor.afterOld": "The “after” columns were checked before later decisions, so they may be out of date. Check again.",
  "tailor.export": "Download Word (rewritten)",
  "tailor.exportFirst": "Check again before downloading",
  "tailor.exportNone": "Accept a change or two, then you can download it.",
  "tailor.exportPdfNew": "Download PDF (rewritten)",
  "tailor.exportingWord": "Preparing Word file…",
  "tailor.exportingPdf": "Laying out PDF…",
  "tailor.exportNewNote": "Your CV on record is a PDF, which cannot be edited in place: these two are your own words, set again. The content is yours; the layout is ours. The Word one you can keep working on.",
  "tailor.refusedNotOffered": "That format is not offered for this CV.",
  "tailor.missedOne": "1 accepted change could not be written into the Word file (that line is set in a table or across a tab); the file does not have it:",
  "tailor.missedMany": "%1 accepted changes could not be written into the Word file (those lines are set in a table or across a tab); the file does not have them:",
  "tailor.refusedUnread": "The CV has not been read into lines yet.",
  "tailor.refusedNoFile": "There is no CV on file to write the changes into. Upload one first.",
  "tailor.refusedBroken": "The Word file no longer reads as the CV that was read (it may have been edited in Word since). Upload it again, or start a new rewrite.",
  "tailor.exportFailed": "The file could not be made — the fault is on our side, not in your CV. Try again in a moment.",
  "tailor.refusedBlank": "The font the PDF is set in cannot draw these lines at all — they would come out blank: %1. Use the Word file (it uses the reader's own fonts), or write those lines in characters this font has.",
  "tailor.refusedUnchecked": "This version has not been checked: a decision changed since the last check. Check again first, then download.",
  "tailor.damagedOne": "1 part of this Word file will not open (most likely damaged in transit or in storage, not by this rewrite). It is carried into the exported file exactly as it is, and your text is unaffected; Word may not be able to show it:",
  "tailor.damagedMany": "%1 parts of this Word file will not open (most likely damaged in transit or in storage, not by this rewrite). They are carried into the exported file exactly as they are, and your text is unaffected; Word may not be able to show them:",
  "tailor.lostGlyphs": "The PDF cannot print these characters — the font it is set in has no glyph for them: %1. On these lines: %2. The Word file has them; it uses the reader's own fonts.",
  "tailor.refusedUnreadable": "This CV could not be read into text — an earlier reading was refused. Upload a different file, then export again.",
  "tailor.refusedMismatch": "The CV's text no longer matches the lines it was read into — usually a CV uploaded a moment ago and not read yet. Wait for that reading, or start a new rewrite.",
  "tailor.exportNote": "What you get is your own file with only the accepted lines rewritten: the layout, the fonts and the header are untouched.",
  "tailor.smellsTitle": "Worth a look before you send it",
  "tailor.smellAi": "%1: “%2” reads like a model wrote it",
  "tailor.smellCoach": "%1: “%2” does not say what you did",
  "card.passPlaceholder": "One line so I can learn",
  "card.passSubmit": "Submit",
  "card.plugin": "The extension fills what it can on the employer page and marks the rest.",
  "card.closesOn": "Deadline %1.",
  "card.changedHead": "The employer has changed this posting",
  "card.changedTitle": "it is now titled “%1”",
  "card.changedPlace": "it is now in %1",
  "card.changedText": "its text was largely rewritten",
  "card.changedJoin": "; ",
  "card.changedEnd": ". The employer's page is the one that holds.",
  "card.closedTitle": "This posting was taken down",
  "card.closedApply": "The employer took it down (noticed: %1); the way to apply may no longer work.",
  "card.closedSent": "The employer took it down (noticed: %1); they may no longer be handling applications.",
  "card.closedRunning": "The employer took the advert down (noticed: %1); whether the process goes on is for them to say.",
  "card.markApplied": "Mark applied",
  "card.notes": "Notes",
  "card.notesPlaceholder": "For you",
  "card.unsave": "Unsave",
  "card.dequeue": "Remove from queue",
  "card.sentDays": "Sent %1 days ago · %2",
  "card.noReply": "No reply yet.",
  "card.replyAsk": "I read an email from %1 that looks like a reply. What did they say?",
  "card.yes": "Yes",
  "card.no": "No",
  "card.gotInvite": "Got an interview invite →",
  "card.rejected": "Rejected",
  "card.otherTime": "Another time",
  "card.strategy": "Strategy",
  "card.skills": "Skills",
  "card.accounts": "Accounts",
  "card.have": "Have",
  "card.adjacent": "Adjacent",
  "card.gap": "Gap",
  "card.mock": "Mock interview →",
  "card.interviewStarted": "Interview started",
  "card.gotOffer": "Got an offer",
  "card.timeline": "This process",
  "card.replyBy": "Reply by %1.",
  "card.openCompare": "Open comparison →",
  "ask.compare": "Help me compare the offers I have.",
  "card.prepFold": "Interview prep",
  "card.scoreHow": "Ten judgements, composed by the weights you set, out of 100.",
  "card.scoreWeights": "See how I rank →",

  // ⓘ beside a number: the button's name for a screen reader (#238)
  "tip.score": "What this score means",
  "tip.closing": "What this number counts",
  "tip.scan": "What these numbers are",
  "tip.ledger": "How these numbers are counted",
  "tip.unrated": "What unrated means",
  "tip.gone": "What taken down means",
  "tip.track": "How these counts are made",
  "tip.report": "What these versions mean",
  "tip.week": "How the two columns are counted",
  "tip.accounts": "Sources and search notes for the interview accounts",
  "tip.deepSources": "Sources for the deep research",
  "card.endedNote": "It will not show up in the front row again.",
  "card.judgmentFold": "Judgment",
  "card.companyLink": "Company · sponsorship →",
  "card.posting": "Original job details",
  "card.postingMore": "Read more",
  "card.postingLess": "Show less",
  "card.translated": "Translated",
  "card.translating": "Translating…",
  "card.tooLongToTranslate": "Too long to translate",
  "card.untranslatable": "Couldn't translate",
  "card.threadFold": "Thread on this role",
  "card.continue": "Continue…",
  "card.seenOn": "Seen on %1 boards: %2",
  "reason.stack": "Stack mismatch",
  "reason.too_senior": "Level too high",
  "reason.too_junior": "Level too low",
  "reason.location": "Place",
  "reason.pay": "Pay",
  "reason.size": "Company size",
  "reason.unsure": "Not sure",

  "co.following": "Following",
  "co.declined": "Declined",
  "co.unreachable": "Unreadable",
  "co.set_aside": "Screened out",
  "co.setAsideOn": "Your hard constraints set aside every posting it has.",
  "co.followUp": "Follow",
  "co.noBoardYet": "No job board found for it yet",
  "co.unfollowNow": "Stop following",
  "co.tryAgain": "Try again",
  "co.siteEdit": "Its careers page address…",
  "co.openCareers": "Open its careers page ↗",
  "co.lookCareers": "Look at its careers page ↗",
  "co.ats": "ATS",
  "ats.page": "careers page",
  "ats.sitemap": "careers site (sitemap)",
  "ats.lever_eu": "lever (EU)",
  "co.open": "Open",
  "co.openCount": "%1 live, %2 matching",
  "co.sponsorship": "Sponsorship",
  "co.sponsorshipScope": "per company · shared by every user",
  "co.evidence": "evidence",
  "co.basics": "The basics",
  "co.size": "Size",
  "co.stage": "Stage",
  "co.hq": "HQ",
  "co.inYourCity": "In your city",
  "co.workingLang": "Working language",
  "co.remote": "Remote",
  "co.unstated": "Unstated",
  "co.openForYou": "Open roles · matching",
  "co.of": "of",
  "co.openOnJobs": "The matching ones are on the jobs page.",
  "co.openArrow": "Open →",
  "co.record": "My record",
  "co.noRecord": "You have not touched this one yet.",
  "co.related": "Related companies",
  "co.notFollowed": "not followed",
  "co.deep": "Deep research",
  "co.deepWhen": "once an interview exists · researched %1",
  "co.deepWait": "Once there is an interview I will dig in: product, tech, team, risks, questions worth asking.",
  "co.notResearched": "This company has not been researched yet.",
  "co.notResearchedBasics": "This company has not been researched yet; below is only the basics on file.",
  "co.product": "Product",
  "co.money": "How they make money",
  "co.tech": "Tech",
  "co.team": "Team",
  "co.risks": "Risks",
  "co.ask": "Worth asking",
  "co.thread": "Company thread",
  "co.note": "Your note",
  "co.notePlaceholder": "Just for you…",
  "co.stated": "stated",
  "co.guessed": "guessed",
  "co.noSuggest": "We will not follow it for you again.",
  "co.retryHint": "If you know their real careers page, put it above and try again.",
  "co.unreadable": "I found it, but I cannot read the openings on its careers page.",
  "co.relook": "I look again every week, and the night the system it runs on is connected.",

  // the companies page (block 4b): the rail, the rows, the residue
  "co.added": "you added it",
  "co.ours": "followed for you",
  "co.oursPosting": "%1 · %2",
  "co.whyOurs": "Why we follow it for you",
  "co.forYou": "%1 matching",
  "co.noneForYou": "no matches",
  "co.recOffer": "offer",
  "co.recInterviewing": "interviewing",
  "co.recInvited": "invited",
  "co.recApplied": "applied to %1",
  "co.recSilent": "silent %1 days",
  "co.recRejected": "turned down",
  "co.recQueued": "%1 queued to apply",
  "co.recSaved": "saved %1",
  "co.declinedShort": "you said no",
  "co.declinedOn": "You said no on %1.",
  "co.unreachableShort": "I cannot read its openings",
  "co.unreachableOn": "Its careers page runs on %1, which I cannot read.",
  "co.tierAccount": "actually interviewed or made an offer to someone who needed sponsorship",
  "co.tierPosting": "stated in a posting",
  "co.tierResearch": "read off public material",
  "co.tierUser": "you told me",
  "co.hqHere": "%1 office (HQ)",
  "co.restNote": "%1 more, not on this card",
  "co.roundNo": "round %1",
  "co.search": "Company, industry, city…",
  "co.searchIgnores": "A search looks at every employer: your record and tracking do not narrow it.",
  "co.rSaved": "Saved",
  "co.rApplied": "Applied",
  "co.rInterviewed": "Interviewed",
  "co.rOffer": "offer",
  "co.matchGroup": "Match",
  "co.matchHigh": "High match open",
  "co.matchMid": "Mid match open",
  "co.placeGroup": "Place",
  "co.industryGroup": "Industry",
  "co.sizeStageGroup": "Size · stage",
  "co.originGroup": "How it got here",
  "co.trackGroup": "Tracking",
  "co.trackCounts": "Counted over every employer, whatever your record group says. “Screened out” is unticked by default.",
  "co.sortRelation": "By relationship",
  "co.sortOpenings": "Matching roles",
  "co.sortName": "Name",
  "co.sortResearched": "Last researched",
  "co.clearAll": "Clear all filters",
  "co.emptyList": "No companies match.",
  "co.listTotal": "%1 companies",
  "co.emptyCard": "Pick a company and its card is here.",
  "rel.similar": "similar",
  "rel.upstream": "upstream",
  "rel.downstream": "downstream",
  "rel.rival": "rival",
  "rel.same_group": "same group",
  "covisa.yes": "Yes",
  "covisa.likely": "Likely",
  "covisa.unknown": "Unknown",
  "covisa.no": "No",

  // jobs page (block 4a)
  "jobs.search": "Company, role, skill, city…",
  "jobs.filters": "Filters",
  "jobs.status": "Status",
  "jobs.pending": "To review",
  "jobs.active": "In progress",
  "jobs.excluded": "Passed",
  "jobs.rejected": "Rejected",
  "jobs.match": "In To review",
  "jobs.lv.high": "High",
  "jobs.lv.mid": "Mid",
  "jobs.lv.low": "Low",
  "jobs.lv.unrated": "Unrated",
  "jobs.unratedTip": "Postings with no band: set aside by your hard constraints before judging (the reasons are in the “%1” group at the bottom), or not read by the judge yet. Press it and they appear in the list.",
  "jobs.gone": "Taken down",
  "jobs.goneTip": "Postings the employer has taken down that you never answered are left out of To review. Tick this and they are back in the list. One you saved or applied to is never hidden when it comes down — it is marked.",
  "jobs.time": "Time",
  "jobs.fetched": "Fetched",
  "jobs.posted": "Posted",
  "jobs.today": "Today",
  "jobs.week": "This week",
  "jobs.month": "This month",
  "jobs.custom": "Custom",
  "jobs.from": "From",
  "jobs.to": "To",
  "jobs.go": "Apply",
  "jobs.place": "Place",
  "jobs.placeInput": "City or country",
  "jobs.fromProfile": "From your profile",
  "jobs.onsiteQ": "Office",
  "jobs.moveQ": "Moving",
  "jobs.hard": "Hard filters",
  "jobs.visaGroup": "Visa",
  "jobs.langGroup": "Working language",
  "jobs.payGroup": "Pay floor",
  "jobs.yours": "Yours: %1",
  "jobs.roles": "Roles",
  "jobs.rolesSearch": "Find a title",
  "jobs.companyGroup": "Company",
  "jobs.setAside": "Set aside before judging",
  "jobs.setAsideNote": "Postings your hard constraints set aside before the judge read them — not the ones you passed on yourself.",
  "jobs.companyInput": "Company name",
  "jobs.boards": "Boards",
  "jobs.mineGroup": "Mine",
  "jobs.pasted": "I brought in",
  "jobs.relevelled": "I overrode the band",
  "jobs.tailored": "CV rewritten",
  "jobs.closingWeek": "Deadline this week",
  "jobs.closed": "Taken down",
  "jobs.deadline": "Deadline",
  "jobs.sort": "Sort",
  "sort.priority": "By priority",
  "sort.match": "Best match",
  "sort.posted": "Posted",
  "sort.seen": "Fetched",
  "sort.closing": "Deadline",
  "sort.company": "By company",
  "jobs.clear": "Clear all",
  "pager.per": "%1 / page",
  "pager.perBox": "Rows per page",
  "pager.at": "Page %1 of %2",
  "pager.jumpBox": "Go to page",
  "pager.jumpHint": "Page",
  "pager.prev": "Previous page",
  "pager.next": "Next page",
  "pager.page": "Page %1",
  "jobs.new": "new",
  "jobs.brought": "you brought this",
  "jobs.closedTag": "taken down",
  "jobs.emptyActive": "Nothing saved or sent yet.",
  "jobs.emptyPending": "No jobs to review here yet.",
  "jobs.emptyHeldBack": "Held back by “In To review” on the left: %1.",
  "jobs.emptyExcluded": "Nothing passed yet.",
  "jobs.emptyRejected": "Nothing rejected yet.",
  "jobs.emptySearch": "Nothing I have read matches that.",
  "jobs.emptyCard": "Pick a row on the left; the card shows here.",
  "jobs.savedDays": "saved %1 days",
  "jobs.sentDays": "sent %1 days",
  "jobs.noReply": "no reply yet",
  "jobs.closesOn": "deadline %1",
  "jobs.roundAt": "round %1 · %2",
  "jobs.timeToConfirm": "time to confirm",
  "jobs.passedLine": "you passed · %1 · %2",
  "jobs.rejectedLine": "rejected · %1",
  "jobs.daysAgo": "%1d ago",
  "jobs.yesterday": "yesterday",
  "jobs.more": "More",
  "jobs.lowReason": "Low match: %1",
  "jobs.unratedReason": "Not read: %1",
  "render.pending": "A few passages are not translated yet. They are shown as written and will switch over on their own.",
  "render.tooLong": "One part of this is too long to send for translation and is shown as written.",
  "render.refused": "A few passages could not be translated and are shown as written.",
  "render.mark": "original",
  "render.why.pending": "Not translated yet. It will switch over on its own.",
  "render.why.tooLong": "Too long to send for translation.",
  "render.why.refused": "This could not be translated.",
  "step.resume": "Read the résumé",
  "step.resume_content": "Read what each position did",
  "step.preferences": "Understand work preferences",
  "step.story": "Enrich profile",
  "step.profile": "Write the positioning overview",
  "step.constraints_check": "Check the constraints",
  "step.select_sources": "Choose the sources",
  "step.report": "Write the position report",
  "step.fetch": "Fetch postings",
  "step.seed": "Find boards for a new direction",
  "step.seed_pairs": "Find boards for a new direction, ahead",
  "step.topup": "Read their own sources",
  "step.companies": "Tidy the employers",
  "step.dedupe": "Remove duplicates",
  "step.scope": "Apply your constraints",
  "step.langs": "Check language requirements",
  "step.feedback": "Learn from feedback",
  "step.judge": "Judge",
  "step.apply_links": "Find where each posting is applied for",
  "step.pairs_left": "Find and read openings for the other directions",
  "step.translate_judgment": "Translate judgements",
  "step.specs": "Extract the specs",
  "step.facts": "Read what postings say for the filter",
  "step.sponsoring": "Read what postings say about visas",
  "step.reading": "Read what each posting asks for",
  "step.hand_off": "Queue the day's searches for this time zone",
  "step.translate_posting": "Translate postings",
  "step.research": "Research employers",
  "step.translate_company": "Translate employer profiles",
  "step.retire": "Retire closed postings",
  "step.reasons": "Sum up reasons",
  "step.report_due": "See whether the report is due a rewrite",
  "step.brief": "Write the morning note",
  "step.forms": "Read application forms",
  "step.questionnaire": "Questionnaire",
  "step.find_similar": "Find similar employers",
  "step.add_board": "Add a job board",
  "step.mail_watch": "Watch for replies",
  "step.linkedin_search": "Find employers on LinkedIn",
  "step.linkedin_resolve": "Find their job boards",
  "step.linkedin_sites": "Look up websites of companies not found by name",
  "step.aggregator_sites": "Find aggregator sites for the countries people look in",
  "step.arbeitnow_boards": "Find job boards behind arbeitnow postings",
  "step.cdx_boards": "Find job boards in the public web index",
  "step.check_boards": "Check where job boards hire",
  "step.admit_boards": "Take found job boards into the market",
  "step.recheck_postings": "Check whether postings no board lists are still open",
  "step.follow_for_them": "Follow employers for you",
  "step.deep": "Research in depth",
  "step.accounts": "Find interview accounts",
  "step.skills": "Skills",
  "step.strategy": "Strategy",
  "step.backup": "Back up",
  "step.retire_runs": "Retire old runs",
  "step.archive_spend": "Archive model spend",
  "step.fx_rates": "Refresh exchange rates",
  "step.retire_visits": "Retire old visits",
  "step.retire_auth": "Retire old sign-in records",
  "step.trial_notices": "Trial reminders",
  "step.unlikely_check": "Check the unlikely sample",
  "step.judge_all": "Read the rest closely",
  "step.take": "Read a pasted link",
  "step.render": "Translate",
  "jobs.back": "← Jobs",
  "jobs.deepTitle": "Review",
  "jobs.endedNoReason": "no reason given",
  "shelf.target_country": "not in your target country",
  "shelf.target_city": "not in the places you chose",
  "shelf.radius": "outside your radius",
  "shelf.needs_permit": "defence / clearance employer",
  "shelf.work_lang": "requires the local language",
  "shelf.direction": "not your direction",
  "shelf.salary_floor": "below your pay floor",
  "shelf.remote": "remote policy does not fit",
  "shelf.start_by": "start date does not fit",
  "shelf.other": "another hard constraint",
  "shelf.defence": "defence or classified work",
  "shelf.declined": "an employer you said no to",
  "shelf.window": "outside your region's time window",
  "shelf.changed": "the employer moved it somewhere you do not look",
  "rejected.noTitle": "the board listed it with no title",
  "rejected.noDescription": "the board listed it with little or no text",
  "jobs.visaRecord": "Sponsorship record: %1 · from %2 postings",
  // 岗位 · 今天 (block 4a, PR2)
  "jobs.allToday": "See all of today's recommendations →",
  "jobs.funnelThisWeek": "This week",
  "jobs.funnelLastWeek": "Last week",
  "jobs.funnelHow": "Calendar weeks in your time zone, starting Monday, counted as of now. Worth a look: openings that arrived that week and were judged worth showing — high, mid and low alike; the cards in the stack are only today's high matches. I answered: openings whose latest change of status falls in that week, answers from a notification included.",
  "jobs.funnelWorth": "worth a look",
  "jobs.funnelAnswered": "I answered",
  "jobs.funnelMotion": "In motion",
  "jobs.funnelCold": "Nothing to report yet. Once the first search finishes and you start saving and applying, this fills in.",
  "jobs.funnelSaved": "Saved",
  "jobs.funnelApplied": "Applied",
  "jobs.funnelInterview": "Interview",
  "jobs.funnelOffer": "Offer",
  "jobs.paste.title": "Paste one",
  "jobs.paste.placeholder": "Posting URL",
  "jobs.paste.look": "Look",
  "jobs.paste.hint": "Already have it / filtered / now added.",
  "jobs.paste.have": "Already have it →",
  "jobs.paste.added": "Never seen it; added now. It will be read within minutes.",
  "jobs.paste.bad": "That does not look like a URL.",
  "jobs.paste.failed": "That did not go in.",
  "jobs.paste.recent": "Recently pasted",
  "jobs.paste.state.new": "queued to read",
  "jobs.paste.state.known": "already held",
  "jobs.paste.state.added": "in the list",
  "jobs.paste.state.found": "found its board",
  "jobs.paste.state.unresolved": "no readable board",
  "jobs.paste.state.failed": "page unreadable",
  "jobs.paste.state.declined": "you said no",
  "shelf.judge": "did not pass the judge",
  // the extension's panel (BLUEPRINT §6); %1 is the count or the name
  "ext.shown": "I showed you this one.",
  "ext.judged": "I read it and decided it was not worth your time.",
  "ext.filtered": "I saw it and dropped it before spending anything.",
  "ext.shelved": "I have it, set aside by the current scope.",
  "ext.unread": "I have it — not read yet.",
  "ext.unseen": "I have never seen it. That is my gap.",
  "ext.employerLede": "This is a company page. Want me to watch their hiring?",
  "ext.find": "Find this employer",
  "ext.findNamed": "Find %1's own board",
  "ext.keeping": "Keeping it…",
  "ext.asking": "Asking the server…",
  "ext.timeout": "The server never answered.",
  "ext.learned": "Kept %1 of your answers — the next form will not ask.",
  "ext.ask": "Ask something…",
  "ext.send": "Send",
  "ext.thinking": "Thinking…",
  "ext.thought": "How it got there",
  "ext.chatHere": "Ask",
  "ext.tailor": "Tailor my CV to this job",
  "ext.tailoring": "Getting it ready…",
  "ext.tailorOpened": "The rewrite lives in the portal — opened in a new tab.",
  "ext.tailorBlocked": "The rewrite lives in the portal — the browser would not let me open a tab.",
  "ext.tailorOpen": "Open the rewrite →",
  "ext.tailorKept": "This job is saved to your list.",
  "ext.tailorNotPosting": "No requirements can be read off this page, so there is nothing to tailor a CV to.",
  "ext.tailorNoCv": "Your CV has to be read once more before it can be rewritten line by line.",
  "ext.tailorToMe": "See it under “My profile” →",
  "ext.tailorFail": "The rewrite could not be started.",
  "ext.keptNew": "Kept. The portal will have a verdict within a minute — nothing to wait for here.",
  "ext.undo": "Undo",
  "ext.keptSame": "I already had this one — on %1's own board. Recorded against it.",
  "ext.keptFail": "Not kept — I could not read a job off this page.",
  "ext.boardOnly": "This is a job board page and I cannot tell who is hiring from it.\nOpen the employer's own site and click the icon there.",
  "ext.save": "Save",
  "ext.pass": "Not for me",
  "ext.saved": "Saved",
  "ext.passed": "Not for me",
  "ext.queued": "In your apply list",
  "ext.queueUp": "Queue to apply",
  "ext.markApplied": "I applied",
  "ext.appliedDone": "Applied",
  "ext.interviewRequested": "Interview invited",
  "ext.interviewing": "Interviewing",
  "ext.offer": "Offer",
  "ext.rejected": "Rejected",
  "ext.http409": "This one is already past applying — change it on the jobs site.",
  "ext.http402": "The free week is over — open the portal to carry on.",
  "ext.why": "Why this one",
  "ext.pause": "What gives me pause",
  "ext.noToken": "No key set — click the extension icon.",
  "ext.offline": "Cannot reach the server.",
  "ext.failed": "That did not go through. Try again?",
  "ext.badToken": "This key no longer works — make a new one in the portal (My profile → Settings) and paste it into the extension's settings.",
  "ext.openSettings": "Open extension settings",
  "ext.notJson": "The server sent a page, not data — probably needs a login.",
  "ext.dock": "Dock as a side panel (bigger)",
  "ext.undock": "Back to a small panel",
  "ext.formHere": "There is a form here: %1 fields",
  "ext.known": "%1 I know",
  "ext.needYou": "%1 need you",
  "ext.yoursAlone": "%1 are yours alone (declarations, self-description)",
  "ext.menus": "%1 are dropdowns — one tap each",
  "ext.doFill": "Fill in what I know",
  "ext.answer": "Answer those %1",
  "ext.keep": "Keep these",
  "ext.back": "Back",
  "ext.retry": "Try again",
  "ext.retrying": "Trying…",
  "ext.left": "%1 to go",
  "ext.skip": "Skip",
  "ext.filled": "Filled %1.",
  "ext.refused": "%1 left empty — the options did not match.",
  "ext.askLede": "Answer once and no later form asks again.",
  "ext.yourWords": "%1 you have to write yourself",
  "ext.confirmName": "Confirm your application name under My profile → Settings → Browser extension",
  "ext.confirmHome": "Confirm your application residence under My profile → Settings → Browser extension",
  "ext.confirmPhone": "Confirm your application phone under My profile → Settings → Browser extension",
  "ext.confirmSalary": "Expected salary left empty: none on record (your minimum salary is never used for it) — set a target salary under My profile → Job search settings, or type it into the form and it will be remembered",
  "ext.confirmSalaryCurrency": "Expected salary left empty: the form asks in a different currency from your target salary, and it is not converted — type it into the form and it will be remembered",
  "ext.assistTitle": "Fill just this one",
  "ext.singleFilled": "Filled.",
  "ext.singleUnknown": "I do not know this one yet — yours to fill.",
  "ext.singleFail": "Could not fill it.",
  "ext.improve": "Draft it with AI",
  "ext.draftLede": "Work this one out with AI, then press Insert.",
  "ext.draftAsk": "Say the points, or how to change it…",
  "ext.insert": "Insert",
  "ext.draftEmpty": "The draft is empty — talk it out with AI first.",
  "ext.looking": "Looking for their board — this usually takes ten to twenty seconds…",
  "ext.finding": "Still looking for their board. When it is done, the result will be on the portal's Companies page.",
  "ext.foundFollowing": "Following %1: its openings go into your daily search.",
  "ext.foundDeclined": "You said no to %1 before. To change your mind, do it in the portal.",
  "ext.foundUnread": "%1's careers page runs on %2, which we cannot read yet. It is on the portal's Companies page.",
  "ext.foundNone": "No board of %1's that we can read. It is on the portal's Companies page.",
  "ext.foundNothing": "No board of this employer's that we can read.",
  "ext.foundFailed": "This page could not be read, so their board could not be found.",
  "ext.findOpen": "See it in the portal →",
  "ext.employerSite": "This is %1's website.",
  "ext.employerUnread": "We cannot read %1's board — keep the jobs you want from here, and they go on its card.",
  "ext.autoOpen": "Open by itself on this site from now on",
  "ext.autoOpenAsked": "Confirm it on the settings page that just opened.",
  "ext.viaCompanyPage": "This page does not name %1's own website. Open their LinkedIn company page and click the icon there — I can read it from that page.",
  "ext.companyPageOpen": "Open the company page →",
  "ext.noSite": "%1's LinkedIn page lists no website of theirs, so I cannot find their own board.",
  "ext.noSitePage": "This page does not name %1's own website, so I cannot find their own board.",
  // ---- the interviews page (block 4c): calendar, the two lists, the reading view
  "iv.prevMonth": "Previous month",
  "iv.nextMonth": "Next month",
  "iv.prevWeek": "Previous week",
  "iv.nextWeek": "Next week",
  "iv.today": "Today",
  "iv.week": "Week",
  "iv.month": "Month",
  "iv.markInterview": "Interview",
  "iv.markUnconfirmed": "To confirm",
  "iv.markDeadline": "Assignment due",
  "iv.kind.screen": "Screen",
  "iv.kind.technical": "Technical",
  "iv.kind.system": "System design",
  "iv.kind.behavioural": "Behavioural",
  "iv.kind.take_home": "Take-home",
  "iv.kind.written": "Written test",
  "iv.kind.onsite": "On site",
  "iv.kind.final": "Final",
  "iv.kind.other": "Other",
  "iv.format.video": "Video",
  "iv.format.phone": "Phone",
  "iv.format.onsite": "On site",
  "iv.format.async": "Async",
  "iv.roundNo": "Round %1",
  "iv.due": "due",
  "iv.unscheduled": "No time yet",
  "iv.theirTime": "their time %1",
  "iv.toConfirm": "Confirm the time",
  "iv.noTimeYet": "No time agreed",
  "iv.cancelled": "Cancelled",
  "iv.roundDone": "Done",
  "iv.timeNo": "That time does not work",
  "iv.upcoming": "Ahead",
  "iv.allDays": "All days",
  "iv.addRound": "Record one",
  "iv.noneAhead": "Nothing scheduled.",
  "iv.ended": "Ended",
  "iv.noneEnded": "Nothing has ended yet.",
  "iv.nothing": "No interviews yet. Mark an opening “interview invited” and it appears here.",
  "iv.back": "← Interviews",
  "iv.joinLink": "Meeting link ↗",
  "iv.packet.deep": "Deep",
  "iv.packet.accounts": "Accounts",
  "iv.packet.skills": "Skills",
  "iv.packet.strategy": "Strategy",
  "iv.packetWhat.deep": "what this company and this role are doing",
  "iv.packetWhat.accounts": "what others were asked here",
  "iv.packetWhat.skills": "what they test, and how much of it you have",
  "iv.packetWhat.strategy": "what to emphasise, what they will push on",
  "iv.reason.none_found": "No interview accounts turned up for this company.",
  "iv.reason.namesake": "Interview accounts turned up, but they may be about a different company with the same name, so they are not used.",
  "iv.reason.no_skills_named": "No skill list for this role has been read yet, so there is nothing to compare.",
  "iv.reason.no_web": "No web search this time.",
  "iv.reason.search_unavailable": "The search service returned an error, so the search did not go through.",
  "iv.reason.model_unavailable": "The writing service returned an error, so this is not complete.",
  "iv.reason.budget": "This preparation ran out of budget before this part was done.",
  "iv.reason.rejected": "Some of what was written did not pass the checks and was not kept.",
  "iv.reason.untranslated": "Translating this into your language did not work.",
  "iv.reason.needs_cv": "The skills in your CV have not been read yet, so there is nothing to compare.",
  "iv.reason.needs_judgment": "This role has not been assessed yet, so there is no strategy.",
  "iv.reason.needs_company": "There is no research on this company yet, so the role could not be looked into.",
  "iv.reason.failed": "This part did not finish.",
  "iv.noneFoundGuess": "No interview accounts turned up for this company; what follows is inferred from the role.",
  "iv.namesakeGuess": "The interview accounts that turned up may be about a different company with the same name; what follows is inferred from the role.",
  "iv.notStarted": "Preparation has not started.",
  "iv.queued": "Queued; the four parts appear here once it has run.",
  "iv.running": "Being prepared; come back in a few minutes.",
  "iv.ranEmpty": "The preparation ran and none of the four came out.",
  "iv.strategy.they_value": "What they value",
  "iv.strategy.emphasise": "Emphasise",
  "iv.strategy.will_be_questioned": "Will be questioned",
  "iv.strategy.ask_them": "Ask them",
  "iv.strategy.sponsorship": "Raising the permit",
  "iv.skillCount": "%1 · core %2 / secondary %3",
  "iv.by.cv": "from your CV",
  "iv.by.model": "judged",
  "iv.unverified": "unverified",
  "iv.source.firsthand": "first-hand",
  "iv.source.employer": "employer",
  "iv.source.aggregator": "aggregator",
  "iv.source.other": "other",
  "iv.sourceLegend": "First-hand = written by someone who interviewed; employer = the company’s own description; aggregator = a compiled list; inferred = my guess from the advert.",
  "iv.snippetOnly": "search snippet only",
  "iv.inferredWhole": "the whole packet is inferred",
  "iv.inferred": "Likely to be asked",
  "iv.inferredCaveat": "Inferred from the advert and related material, not an account of an actual interview.",
  "iv.deep": "Deep research",
  "iv.team": "Team",
  "iv.problem": "What they work on",
  "iv.stack": "Stack",
  "iv.business": "How they make money",
  "iv.risks": "Risks",
  "iv.process": "Hiring process",
  "iv.angles": "Points to discuss",
  "iv.news": "Recent developments",
  "iv.viewResearch": "View research",
  "iv.hideResearch": "Hide research",
  "iv.sourceDetails": "Search and sources:",
  "iv.roleSources": "Job sources:",
  "iv.companySources": "Company sources:",
  "iv.notePrompt": "What they asked / how it went / next",
  "iv.notePlaceholder": "One line after the round…",
  "iv.share": "Contribute this round’s notes anonymously: your identity is stripped, the questions and the process stay.",
  "iv.saveNote": "Save",
  "iv.markDone": "Done",
  "iv.saveFailed": "Not saved: %1",
  "iv.addRoundN": "＋ Record round %1",
  "iv.fieldKind": "Kind",
  "iv.fieldWhen": "When",
  "iv.fieldMinutes": "Minutes",
  "iv.fieldFormat": "Format",
  "iv.fieldLink": "Meeting link",
  "iv.fieldLang": "Language",
  "iv.fieldWho": "Interviewers",
  "iv.saveRound": "Record",
  "iv.cancel": "Cancel",
  "round.title": "Invitation received: record this round",
  "round.titleNext": "Interviewing: record this round",
  "round.titleTime": "Add the interview time",
  "round.titleAdd": "Record an interview round",
  "round.later": "Fill in later",
  "round.laterNote": "“Fill in later” still changes the status; you can add the time on the card afterwards.",
  "round.needWhen": "the time is needed first",
  "card.noTime": "No interview time yet, so it is not on your calendar.",
  "card.addTime": "Add the time",

  "strength.hard": "hard",
  "strength.strong": "strong",
  "strength.mild": "mild",
  "profile.sec.positions": "Work history",
  "profile.sec.skills": "Skills",
  "profile.sec.about": "About",
  "profile.sec.education": "Education",
  "profile.sec.publication": "Publications",
  "profile.sec.certification": "Certifications",
  "profile.sec.award": "Awards",
  "profile.sec.project": "Projects",
  "profile.sec.other": "Other",
  // ---- 我的资料（块 4d）：关于我 / 规则 / 设置 与定位报告
  "me.tab.about": "About you",
  "me.tab.rules": "Job search settings",
  "me.tab.settings": "Settings",
  "me.ask.one": "One thing to confirm",
  "me.ask.rule": "This would change what you are shown — your call",
  "me.ask.shelve": "Set this kind aside?",
  "me.ask.report": "Your position report is ready",
  "me.ask.generic": "Something is waiting for your answer.",
  "me.ask.placeholder": "Answer in your own words…",
  "me.ask.send": "Answer",
  "me.name.title": "Your name on application forms",
  "me.name.full": "Full name",
  "me.name.first": "First name",
  "me.name.last": "Last name",
  "me.name.unconfirmed": "Not confirmed yet. The extension leaves name fields for you until you confirm.",
  "me.name.confirmed": "Confirmed — forms are filled with this.",
  "me.name.save": "Confirm",
  "me.cv.title": "Your CV",
  "me.cv.upload": "Upload",
  "me.cv.replace": "Replace",
  "me.cv.sending": "Uploading…",
  "me.cv.tooBig": "Over 10MB",
  "me.cv.same": "That is the file already on record — nothing changed.",
  "me.cv.none": "No CV yet. Upload one and I will not ask you anything I can read from it.",
  "me.cv.meta": "%1 KB · uploaded %2 · %3 positions · %4 degrees · %5 skills",
  "me.cv.inProgress": "in progress",
  "me.cv.unread": "Not read yet — it is queued, and will be within minutes.",
  "me.cv.detailsPending": "Positions and degrees are read; what each position did and the other skills are still being read.",
  "me.cv.detailsRefused": "Positions and degrees are read, but what each position did and the other skills could not be — a new résumé is read again.",
  "me.cv.failed": "This file could not be read: %1. Save a fresh copy and upload that, or upload a PDF.",
  "me.cv.why.no_text": "there is no text in it to read — most likely a scan or a picture",
  "me.cv.why.locked": "it has a password on it, or it is an old .doc",
  "me.cv.why.other_type": "it is not a PDF or a Word document",
  "me.cv.why.damaged": "the file is damaged",
  "me.cv.why.unreadable": "reading it failed",
  "me.cv.refused": "I could not read this CV: %1, so none of it was recorded. Upload the same file again and I will read it again — or try a Word (.docx) version.",
  "me.cv.why.refused": "what I read out of it did not pass my own checks",
  "me.cv.download": "Download original",
  "me.cv.earlier": "Earlier CVs",
  "me.cv.earlierOn": "uploaded %1",
  "me.cv.earlierMore": "%1 more",
  "me.cv.fold": "What I read out of it",
  "me.cv.wrong": "Read it wrong? Replace the CV, or tell me in the conversation (\"Go is working knowledge\") and I will record it as a revision of your profile. Not editable here: an edit here would be a claim your CV does not support.",
  "me.doc.profile": "Your profile · revision %1",
  "me.doc.at": "changed %1",
  "me.doc.never": "not written yet",
  "me.doc.emptyProfile": "No profile yet. Upload a CV, or tell me in the conversation what you are after.",
  "me.doc.ownOnly": "This box is the part of your profile you and the agent talked into being. What is written for you is kept as it is and cannot be edited here:",
  "me.doc.overviewNote": "“Positioning and background” is drawn from your CV, your settings and your answers, and is rewritten when you upload a new CV.",
  "me.doc.notesNote": "“Location and work-mode preferences” is a summary of your job-search settings and follows them.",
  "profile.block.profile_overview": "Positioning and background",
  "profile.block.job_search_notes": "Location and work-mode preferences",
  "profile.block.learned": "Learned from your feedback",
  "me.doc.notesLink": "Change it in settings",
  "me.doc.edit": "Edit",
  "me.doc.save": "Save",
  "me.doc.conflict": "If your part changed elsewhere while this was open — the conversation noted something, say — the save is refused; reload and edit again. Changes to the parts the system writes do not stop it.",
  "me.src.web": "you edited it",
  "me.src.chat": "from the conversation",
  "me.src.resume": "from your CV",
  "me.src.criterion": "a rule you confirmed",
  "me.src.constraint": "rewritten with a constraint",
  "me.src.question": "a question you answered",
  "me.src.feedback": "from your feedback",
  "me.src.unknown": "no source recorded",
  "me.hc.permitNo": "not needed",
  "me.hc.direction": "Target direction",
  "me.hc.hint.salary_floor": "80k",
  "me.report.title": "Market position report",
  "me.report.locked": "To write it, I still need:",
  "me.report.need.resume": "a CV",
  "me.report.need.profile": "a profile",
  "me.report.need.market": "this month's market",
  "me.report.need.questions": "%1 unanswered questions",
  "me.report.lockedHint": "The button lights when that list is complete.",
  "me.report.ready": "Inputs are complete: profile v%1 · market %2",
  "me.report.making": "Writing the report…",
  "me.report.retry": "Write it again",
  "me.report.failedHint": "That one did not get written. The reason is above; press to try again.",
  "me.report.failed.money": "The budget ran out before it was written. Raise it and try again.",
  "me.report.failed.refused": "What the model wrote failed the checks twice (a quotation that did not match, or the wrong shape). Trying again usually works.",
  "me.report.failed.timeout": "It was still writing after fifteen minutes and was cut off. Try again.",
  "me.report.failed.provider": "The model errored out and nothing was written. Try again.",
  "me.report.failed.unknown": "It did not finish and left no reason — most likely interrupted part-way. Try again.",
  "me.report.writingHint": "It is queued. This card will change by itself when it is done.",
  "me.report.make": "Write it",
  "me.report.again": "Write it again",
  "me.report.open": "Open the report →",
  "me.report.back": "← About you",
  "me.report.written": "written %1 · %2 in all",
  "me.report.same": "Nothing it was written from has moved since.",
  "me.report.moved": "Moved since: %1",
  "me.report.versions": "%1 earlier reports",
  "me.report.from": "profile v%1 · %2",
  "me.report.head": "Market position report · %1",
  "me.report.empty": "This report has no sections.",
  "me.report.howTitle": "What it was written from",
  "me.report.how": "The CV and the profile are versions: only a change moves them. Your rules move when one is added, retired or reworded. The market moves with the week and the scale of your recommendations — a new week, or their number doubling or halving; the report is also rewritten once when your first search finishes.",
  "me.report.market.searching": "before the first search finished",
  "me.report.market.week": "week of %1",
  "me.report.input.resume": "CV",
  "me.report.input.profile": "profile",
  "me.report.input.market": "market",
  "me.report.stillAsking": "There are still unanswered questions; answering them makes the next one sharper.",
  "me.report.s.summary": "In one line",
  "me.report.s.strengths": "Your strengths",
  "me.report.s.positioning": "What to aim at",
  "me.report.s.market": "What the market asks for",
  "me.report.s.gaps": "Your gaps",
  "me.report.s.next_steps": "This week",
  "me.w.title": "How I order things",
  "me.w.lede": "Tapping a filter raises its factor (%1). Decisions and the reasons you give do not move these weights; they become rules further down this page. The rest use the default, or what you set below.",
  "me.w.edit": "Adjust",
  "me.w.save": "Save",
  "me.w.reset": "Back to default",
  "me.w.saveHint": "The list reorders on the new weights as soon as you save.",
  "me.w.f.stack": "Stack",
  "me.w.f.fit": "Fit",
  "me.w.f.where": "Place works for you",
  "me.w.f.reach": "How many can apply",
  "me.w.f.age": "How new",
  "me.w.f.chance": "Odds of a reply",
  "me.w.f.level": "Level",
  "me.w.f.visa": "Visa",
  "me.w.f.stability": "How solid",
  "me.w.f.pay": "Pay",
  "me.w.why.default": "default",
  "me.w.why.attention": "filtered %1×",
  "me.w.why.own": "you set this",
  "me.w.why.stack": "a multiplier, not adjustable",
  "me.learned.title": "Recently learned",
  "me.learned.where": "What you confirm becomes one of your rules, which the judge reads word for word.",
  "me.rules.n": "%1",
  "me.rules.none": "Nothing confirmed yet.",
  "me.rules.title": "Rules",
  "me.rules.lede": "The rules in force; the judge reads them word for word. Retire one and the next run stops applying it; a hard one rules openings out.",
  "me.rules.add": "Add a rule",
  "me.rules.what": "One rule, one sentence",
  "me.rules.retire": "Retire",
  "me.rules.group.auto": "Rules in force without your confirmation",
  "me.rules.group.confirmed": "Rules you confirmed",
  "me.report.input.criteria": "rules",
  "me.doc.rules.count": "Rules in force: %1",
  "me.doc.rules.quoted": " (%1)",
  "me.doc.rules.item": "%1: “%2”",
  "me.doc.rules.sep": "; ",
  "me.doc.rules.more": "%1 more",
  "me.doc.rules.link": "Job search settings → Rules",
  "me.doc.learnedNote": "“Learned from your feedback” is what the nightly pass learned from your pass reasons, comments and form answers.",
  "me.src.rules": "the rules changed",
  "me.doc.correctionHeading": "Resume fact correction",
  "me.reasons.title": "Why you pass",
  "me.reasons.lede": "Ordered by how often you choose them; the most used come first on a card.",
  "me.reasons.uses": "used %1×",
  "me.reasons.teaser": "%1 reasons · most used: %2",
  "me.reasons.teaserNone": "%1 reasons, none used yet",
  "me.set.on": "on",
  "me.set.off": "off",
  "me.set.turnOn": "Turn on",
  "me.set.turnOff": "Turn off",
  "me.set.switchFailed": "That didn't change. Please try again.",
  "wait.working": "Saving…",
  "wait.failed": "That didn't go through. Please try again.",
  "me.set.ch.title": "Notifications",
  "me.set.ch.lede": "Email brings the morning list and trial reminders; Slack also carries questions, reports, leads and interview preparation. Everything else is on the site. Turning an address off stops everything sent to it.",
  "me.set.ch.none": "No address to reach you on yet — nothing can be sent.",
  "me.set.ch.kind.email": "Email",
  "me.set.ch.kind.slack": "Slack",
  "me.set.ch.kind.whatsapp": "WhatsApp",
  "me.set.ch.kind.telegram": "Telegram",
  "me.set.ch.since": "added %1",
  "me.set.ch.quiet": "quiet %1–%2",
  "me.set.ch.events": "only: %1",
  "me.set.ch.remove": "Disconnect",
  "me.set.ch.removeTitle": "Disconnect “%1”?",
  "me.set.ch.removeAsk": "Once disconnected, pushes and chat here both stop; to get them back, connect it again.",
  "me.set.ch.removeAskPush": "Once disconnected, nothing is pushed here any more; to get it back, connect it again.",
  "me.set.ch.push": "Push",
  "me.set.ch.loginEmail": "This is your login email, so it cannot be disconnected — change the address under Account, or use the switch on the right to stop the mail.",
  "me.set.days.title": "Morning letter",
  "me.set.days.hint": "A letter goes out on the mornings you pick; those are the days a batch of verdicts is sent.",
  "me.set.days.none": "No day picked: no morning letter goes out.",
  "me.set.auto.title": "What runs on its own",
  "me.set.auto.lede": "These two are the only switches anything reads: each decides whether marking a status starts a run of work on its own.",
  "me.set.auto.similar": "After you mark one applied, go looking for more like it",
  "me.set.auto.what.similar": "On: marking an opening applied queues segment S4 — similar companies and openings, and any lead you accept becomes a new board. Off: it only records that you applied.",
  "me.set.auto.prep": "After you mark an interview requested, prepare the material",
  "me.set.auto.what.prep": "On: marking a role interview invited starts preparing four packets — research on the company and the role, interview accounts, a skill-by-skill comparison and a strategy. Off: nothing is prepared, and there is no other place to start it.",
  "me.set.auto.onlyTwo": "That is all of them. Reading your mailbox, a nightly hour, autofill levels, mass apply — none of that is built, so none of it is drawn here as a switch.",
  "me.set.ext.title": "Browser extension",
  "me.set.ext.identity": "Application form details",
  "me.set.ext.identityHint": "Suggestions come from your existing details. Confirm the name, residence and phone you want on applications separately. These choices only affect extension form filling.",
  "me.set.ext.residence": "Residence",
  "me.set.ext.place": "City, country or full residence",
  "me.set.ext.phone": "Phone",
  "me.set.ext.number": "Phone number",
  "me.set.ext.confirmed": "Confirmed for application forms.",
  "me.set.ext.unconfirmed": "Not confirmed; the extension leaves this field for you.",
  "me.set.ext.noSource": "No existing detail; enter one to confirm",
  "me.set.ext.source.said": "From details you entered",
  "me.set.ext.source.resume": "From your current CV",
  "me.set.ext.source.account": "From your account",
  "me.set.ext.source.verified": "From your verified number",
  "me.set.ext.direct": "Email and links use your existing details without another confirmation.",
  "me.set.ext.email": "Email",
  "me.set.ext.website": "Website",
  "me.set.ext.none": "No key yet: the extension cannot connect.",
  "me.set.ext.mint": "Make a key",
  "me.set.ext.revoke": "Revoke",
  "me.set.ext.on": "Connected · this key was made %1",
  "me.set.ext.replace": "Replace with a new key",
  "me.set.ext.one": "An account has one key. Using the extension in more than one browser or on more than one computer? Paste the same key into each when you make it; replace it, and replace it everywhere.",
  "me.key.title": "Your extension key",
  "me.key.titleReplace": "Replace your key?",
  "me.key.replaceBody": "The key you have now stops working at once, and every browser the extension is installed in will need the new one.",
  "me.key.replaceYes": "Replace it",
  "me.key.cancel": "Cancel",
  "me.key.making": "Making the key…",
  "me.key.failed": "The key was not made — try again.",
  "me.key.again": "Try again",
  "me.key.once": "Shown this once — copy it now. Once this closes, it cannot be seen again.",
  "me.key.copy": "Copy",
  "me.key.copied": "Copied",
  "me.key.copyByHand": "It is selected — press ⌘C / Ctrl+C to copy it.",
  "me.key.next": "Put it in the extension: “Open extension settings” in its panel, or right-click the extension icon → Options; paste it and save.",
  "me.key.done": "Done",
  "me.set.ext.shownOnce": "A key is shown once, at the moment it is made; what is kept here is its hash, so it cannot be looked up again — if you lose it, replace it with a new one.",
  "me.set.acct.title": "Account",
  "me.set.acct.email": "Sign-in email",
  "me.set.acct.noEmail": "none recorded",
  "me.set.acct.since": "here since %1",
  "me.set.acct.lang": "Email and push language",
  "me.set.acct.langNote": "Messages sent to you by email, Slack and WhatsApp are written in this language, and your profile, rules and positioning report are kept in it.",
  "me.set.acct.tz": "Time zone",
  "me.set.acct.tzHint": "Europe/Berlin",
  "me.set.acct.tzNote": "Every date on these pages, and which day the morning letter counts as, is read in this zone.",
  "me.set.acct.save": "Save",
  "me.set.acct.delete": "To have the account and its data deleted, write to us:",
  "me.set.acct.deleteSubject": "Delete my account",
  "me.set.export.title": "Export",
  "me.set.export.short": "Download your personal data.",
  "me.set.export.what": "One zip: the CVs you uploaded and the files you sent in conversations, as they were, and one document with the rest — your account, profile, search settings and rules, conversations, answered questions, decisions on jobs and interviews — with the same in a machine-readable data.json. Jobs and companies as we collected them, and the service's own records, are not in it; write to us if you want those.",
  "me.set.export.go": "Export my data",
  "mine.title": "My data at Counting",
  "mine.toc": "Contents",
  "mine.sec.about": "About this file",
  "mine.sec.account": "Account",
  "mine.sec.profile": "Profile",
  "mine.sec.resume": "Uploaded CVs",
  "mine.sec.search": "Search settings and rules",
  "mine.sec.threads": "Conversations with the agent",
  "mine.sec.questions": "Questions you answered",
  "mine.sec.jobs": "Your decisions on jobs",
  "mine.sec.interviews": "Interviews",
  "mine.about.intro": "This file holds what you gave Counting and what is about you yourself. The same content is in data.json, machine-readable, in the same zip.",
  "mine.about.files": "Also in the zip: resume/ holds the CVs you uploaded, attachments/ the files you sent in conversations.",
  "mine.about.at": "Exported",
  "mine.about.tz": "Times are in",
  "mine.about.left": "Not included",
  "mine.left.jobs": "Jobs and companies as we collected or wrote them up, and how we judged and scored them",
  "mine.left.system": "The service's own records (runs, usage, visits and the like)",
  "mine.left.billing": "Payment records",
  "mine.left.tailor": "Rewritten CVs",
  "mine.about.ask": "If you want any of this, write to %1.",
  "mine.about.askAnyway": "If you want any of this, write to us.",
  "mine.about.lost": "Files that could not be taken and are not in the zip",
  "mine.file.missing": "the file is gone",
  "mine.file.changed": "the file is not the one kept",
  "mine.file.gone": "only the record is left; the file was deleted",
  "mine.acct.email": "Email",
  "mine.acct.phone": "Phone",
  "mine.acct.lang": "Language",
  "mine.acct.tz": "Time zone",
  "mine.acct.since": "Signed up",
  "mine.profile.doc": "About me",
  "mine.profile.docAt": "This document last changed",
  "mine.profile.experience": "Experience",
  "mine.profile.education": "Education",
  "mine.profile.skills": "Skills",
  "mine.profile.items": "Other",
  "mine.exp.period": "When",
  "mine.exp.location": "Where",
  "mine.exp.summary": "Summary",
  "mine.exp.claims": "Highlights",
  "mine.exp.stack": "Stack",
  "mine.period.now": "now",
  "mine.edu.degree": "Degree",
  "mine.edu.field": "Field",
  "mine.skill.kind.language": "Programming languages",
  "mine.skill.kind.framework": "Frameworks",
  "mine.skill.kind.tool": "Tools",
  "mine.skill.kind.platform": "Platforms",
  "mine.skill.kind.domain": "Domains",
  "mine.skill.kind.practice": "Practices",
  "mine.skill.kind.human_language": "Languages",
  "mine.skill.kind.other": "Other",
  "mine.skill.level.native": "native",
  "mine.skill.level.proficient": "proficient",
  "mine.skill.level.working": "working",
  "mine.skill.level.familiar": "familiar",
  "mine.item.kind": "Kind",
  "mine.item.publication": "Publication",
  "mine.item.certification": "Certification",
  "mine.item.award": "Award",
  "mine.item.project": "Project",
  "mine.item.other": "Other",
  "mine.item.detail": "Detail",
  "mine.item.date": "Date",
  "mine.cv.file": "File",
  "mine.cv.first": "First uploaded",
  "mine.cv.last": "Last uploaded",
  "mine.cv.current": "In use now",
  "mine.yes": "yes",
  "mine.no": "no",
  "mine.search.settings": "Search settings",
  "mine.search.rules": "Rules in force",
  "mine.search.reasons": "Your own reasons for passing",
  "mine.search.switches": "Switches",
  "mine.thread.kind": "Kind",
  "mine.thread.started": "Started",
  "mine.thread.files": "Files",
  "mine.thread.unsent": "Files attached but never sent",
  "mine.who.you": "You",
  "mine.who.agent": "Agent",
  "mine.q.asked": "Asked by the agent",
  "mine.q.answer": "Your answer",
  "mine.q.at": "Answered",
  "mine.q.forms": "Answers for application forms",
  "mine.q.value": "Answer",
  "mine.job.unknown": "The job is no longer on file",
  "mine.job.reasons": "Reasons",
  "mine.job.note": "Note",
  "mine.job.sent": "Pages you sent from the extension",
  "mine.sent.url": "Address",
  "mine.sent.company": "Company",
  "mine.sent.state": "What became of it",
  "mine.sent.at": "Sent",
  "mine.iv.rounds": "Rounds",
  "mine.iv.time": "Time",
  "mine.iv.minutes": "Length (minutes)",
  "mine.iv.format": "Format",
  "mine.iv.interviewers": "Interviewers",
  "mine.iv.link": "Meeting link",
  "mine.iv.notes": "Notes",
  "mine.iv.state": "State",
  "mine.round.proposed": "time to confirm",
  "mine.round.confirmed": "agreed",
  "mine.iv.sponsorSay": "How to raise it",
  "mine.iv.sponsorConfirm": "What to confirm",
  "mine.iv.notCovered": "What the material did not cover",
  "mine.iv.prepare": "To prepare",
  "mine.iv.questions": "Likely questions",
  "mine.iv.skillNote": "Note",
  "me.set.end.title": "Ending the search, or starting again",
  "me.set.end.ended": "Recorded as ended on %1.",
  "me.set.end.end": "I found a job",
  "me.set.end.restart": "Start looking again",
  "me.set.end.honest": "“I found a job” stops it looking for you; “Start looking again” starts it again. Letters already queued are unaffected — those are turned off in the channels above.",
  "me.hc.work_lang": "Working language",
  "me.hc.location_notes": "Location and work mode",
  "me.hc.currency": "Currency",
  "me.hc.salary_floor": "Salary floor",

  // ---- Home (block 4f): the six stages — the blue card, the week, needs a look, what it did, the conversation; stage 0's mirror
  "action.confirm.time.yes": "Works",
  "action.confirm.time.no": "Does not work",
  "action.confirm.criterion.yes": "Set aside",
  "action.confirm.criterion.no": "Keep them",
  "action.confirm.place_modes.yes": "Yes, there too",
  "action.confirm.place_modes.no": "No, any mode there",
  "home.scan.k": "Today · scan",
  "home.scan.line": "What I sent you today. Low matches stay out of the push by your rules.",
  "home.scan.none": "No search results yet. The first batch will appear after your first search.",
  "home.scan.untouched": "New this week, untouched",
  "home.scan.untouchedN": "high %1 · mid %2",
  "home.scan.open": "Open opportunities →",
  "home.motion.k": "In motion",
  "home.motion.closing": "Deadline soon",
  "home.motion.closingNote": "How many of the ones you saved or queued close within seven days.",
  "home.motion.open": "Open Jobs →",
  "home.iv.k": "Next interview",
  "home.iv.today": "today",
  "home.iv.tomorrow": "tomorrow",
  "home.iv.inDays": "in %1 days",
  "home.iv.round": "Round %1 · %2",
  "home.iv.prep": "Open interview prep →",
  "home.iv.noRound": "The invitation is in; the time is not written down yet. Write it on the interviews page so the calendar and the prep can follow.",
  "home.iv.write": "Write the time →",
  "home.offers.k": "In motion",
  "home.offers.n": "%1 offers",
  "home.offers.open": "Open comparison →",
  "home.done.k": "Afterward",
  "home.done.ended": "Marked “search over” on %1.",
  "home.done.scope": "Your search scope is still here",
  "home.done.scopeSub": "The rules, the saved ones and these accounts all stay. One step brings them back.",
  "home.done.restart": "Start again →",
  "home.done.data": "Your data",
  "home.done.dataSub": "Export what you gave us (CV, profile, settings, conversations and more, with a machine-readable data.json).",
  "home.done.settings": "Go to settings →",
  "home.done.say": "Letters and the nightly pass",
  "home.done.saySub": "Letters already queued still go out; after that the nightly pass no longer runs for you. To start again, press “Start looking again” in settings.",
  "home.ledger.k": "%1 weeks",
  "home.ledger.since": "since %1",
  "home.ledger.week": "The last week: read %1, %2 worth a look.",
  "home.ledger.saved": "saved",
  "home.ledger.applied": "applied",
  "home.ledger.interview": "interviewed",
  "home.ledger.offer": "offers",
  "home.ledger.ruler": "Cumulative: “applied” counts the ones that went on to interviews, offers and rejections. The funnel on the jobs page counts what stands now; the two are not meant to match.",
  "home.week.k": "My interview calendar",
  "home.week.all": "Full calendar →",
  "home.week.none": "No interviews this week.",
  "home.story.title": "%1 questions about your experience",
  "home.story.lede": "Optional. Your answers go into your profile overview, and the next searches use them.",
  "home.story.open": "Answer",
  "home.story.dialog": "What your résumé can’t quite tell us",
  "home.story.left": "%1 left",
  "home.story.answer": "Your answer",
  "home.story.answerPh": "A concrete fact or two is enough.",
  "home.story.save": "Save",
  "home.story.skip": "Skip this one",
  "home.story.skipAll": "Skip all",
  "home.story.note": "When you close this, your profile overview is rewritten from your answers, from the next search on.",
  "home.story.failed": "Could not save (%1). Try again.",
  "home.story.gone": "That question is gone: answered elsewhere, or your résumé changed.",
  "home.story.closeFailed": "Your answers are saved, but the rewrite could not be queued (%1). Close again to retry.",
  "home.look.k": "Needs a look",
  "home.look.lead": "A few things are still on the table, waiting for you.",
  "home.look.empty": "Nothing waits on you today. That is a result too.",
  "home.look.open": "Open →",
  "home.look.today_ready": "Today's picks are in",
  "home.look.quiet_day": "No new high matches today",
  "home.look.question": "A question waits for your answer",
  "home.look.reply_seen": "%1 replied",
  "home.look.prep_ready": "Prep for %1 is ready",
  "home.look.report_ready": "The position report is written",
  "home.look.time_confirm": "%1 sent a time — confirm it",
  "home.look.offer_decision": "The offer from %1 waits on you",
  "home.look.roundWhen": "%1 · %2 · round %3 · %4",
  "home.look.reschedule": "Reschedule on the interviews page →",
  "home.look.pushed": "pushed · %1",
  "home.did.k": "What it did",
  "home.did.teaser": "%1 new today: %2 high / %3 mid / %4 low.",
  "home.did.teaserNone": "No job search has run for you yet.",
  "home.did.run": "Last run",
  "home.did.runLine": "%1 new postings today, %2 passed your hard constraints, judged %3: %4 high / %5 mid / %6 low.",
  "home.did.budgetLeft": "The rest from this run will be judged next time.",
  "home.did.runCite": "Source: the run of %1, %2–%3.",
  "home.did.learned": "Learned",
  "home.did.rule": "%1 · %2",
  "home.did.ruleCite": "Source: %1",
  // A rule as it stands once settled — one wording wherever a settled rule
  // is shown: the home's 学到, the divider under the conversation that
  // proposed it (Issue 556).
  "rule.settled.confirmed": "Answered: kept · %1",
  "rule.settled.declined": "Answered: no · %1",
  "rule.settled.retired": "Retired · %1",
  "home.did.learnedNone": "No new rule learned this week.",
  "home.talk.k": "Thread",
  "home.talk.title": "Ask anytime",
  "home.first.k": "First search",
  "home.first.elsewhere": "anywhere else",
  "home.first.noMode": "none stated",
  "home.first.nowhere": "not considered",
  "home.first.progressTitle": "Searching the real market now",
  "home.first.doneTitle": "Your first search has finished",
  "home.first.stoppedTitle": "The first search has stopped",
  "home.first.safe": "You can safely leave this page; the search keeps running in the background.",
  "home.first.state.queued": "Queued and waiting for the search worker.",
  "home.first.state.unknown": "The request was taken; waiting for a verifiable run record.",
  "home.first.state.failed": "This search did not finish. Verifiable results and the failure state are preserved.",
  "home.first.state.stuck": "The search has made no recent progress and needs attention. Its verifiable state is preserved.",
  "home.first.state.partial": "This round read this far; the rest are left for the next one.",
  "home.first.state.partialExtras": "Every opening was read. Some background work did not finish this time; the results below are unaffected.",
  "home.first.state.done": "The first search has finished.",
  "home.first.phase.finding": "Looking for openings on the market.",
  "home.first.phase.reading": "Reading the openings against your criteria.",
  "home.first.phase.extras": "Ready to look at now: %1. The rest is still being put together.",
  "home.first.phase.more": "Still finding openings for your other roles and places.",
  "home.first.phase.moreReady": "Ready to look at now: %1. Still finding openings for your other roles and places.",
  "home.first.phase.extrasEmpty": "Every opening has been read; none of them is a displayable high or mid match this time.",
  "home.first.phase.extrasEmptyLeft": "No displayable high or mid match among the sources read so far; the rest are read tonight.",
  "home.first.phase.sorting": "Every opening has been read; the cards are being put together.",
  "home.first.phase.stopping": "Something went wrong in this search; it is winding down.",
  "home.first.state.cardsShort": "Every opening was read, but some could not be turned into cards this round; below is what could.",
  "home.first.retry": "Retry the first search",
  "home.first.retrying": "Queueing retry…",
  "home.first.retryError": "The retry could not be queued. Your previous search state is unchanged.",
  "home.first.notifyTitle": "Optional notifications",
  "home.first.notifyLede": "Connect more channels so nothing reaches you late.",
  "home.first.notify.email": "Email",
  "home.first.notify.slack": "Slack",
  "home.first.notify.whatsapp": "WhatsApp",
  "home.first.notify.telegram": "Telegram",
  "home.first.resultsK": "First batch",
  "home.first.resultsTitle": "Your first roles worth a closer look",
  "home.first.resultsSub": "Showing %1 of %2 real matches.",
  "home.first.resultsSoFar": "%1 ready so far — the rest is still being read and will be added as it comes.",
  "home.first.empty": "The first search finished without a displayable high or mid match. Counting AI will not loosen your hard constraints to fill this list.",
  "home.first.emptyWaiting": "Your first batch will appear here. The search is still running, and ready roles will be added as they arrive.",
  "home.first.emptyStopped": "No roles are ready to show from this run yet. The first search card explains where the search or card preparation stopped.",
  "home.first.sourcesLeft": "%1 of your sources could not be read in time; they are read tonight, and new roles appear in Today's picks tomorrow morning.",
  "home.first.emptySourcesLeft": "No displayable high or mid match among the sources read so far; the rest are read tonight, and new roles appear in Today's picks tomorrow morning. Counting AI will not loosen your hard constraints to fill this list.",
  "home.first.open": "Open",
  "home.first.all": "View all jobs →",
  "home.first.criteria": "Your search criteria",
  "home.first.criteriaOpen": "Review or change criteria →",
  "home.first.report": "Market positioning report",
  "home.first.reportOpen": "View report →",
  "home.first.reportWriting": "The report is being written from the same résumé, profile and target market.",
  "home.first.reportFailed": "The report was not written this time; open it to see why or retry.",
  "home.first.ask": "Ask about this batch",
  "home.first.ask1": "Why is the first role ranked first?",
  "home.first.ask2": "Which role best fits the work I want to keep doing?",
  "home.first.askEmpty1": "Why did no role clear my hard constraints?",
  "home.first.askEmpty2": "Which constraint is narrowing the market most?",
  "home.first.opener.lead": "This search read %1 and found %2 worth a close look.",
  "home.first.opener.topOne": "At the top:",
  "home.first.opener.topTwo": "The top two:",
  "home.first.opener.ask": "Ask me why they rank this way or which one suits you best — or open one in the list for the details.",
  "home.first.opener.askOne": "Ask me why it is at the top or whether it suits you — or open it in the list for the details.",
  "home.first.opener.empty": "The first-batch tool found no displayable high or mid match.",
  "home.first.opener.kept": "I have kept your hard constraints unchanged.",
  "home.first.opener.running": "The first search has not finished yet; openings appear on this page as they are read.",
  "home.first.opener.stopped": "The first search did not finish this time.",
  "home.first.opener.change": "To change the criteria, just say so — the next round uses them.",
  "home.opener.reportTyping": "Position report in progress",
  "home.opener.reportOpen": "Open the position report →",
  "home.opener.reportStalled": "Your position report did not get written this time.",
  "home.opener.reportWhy": "See why, or write it again →",
  "home.opener.scan": "Today's scan: %1 high / %2 mid / %3 low. %4 high and %5 mid this week still untouched. Change a rule or skip a role — just say it.",
  "home.opener.scanNone": "No job search has run for you yet. If you want to change a rule first, just say it.",
  "home.opener.motion": "Today's high matches are on this page. Ask which to open first, or tell me what to change.",
  "home.opener.iv": "%1 is the hard point. Anything to go over, just say it.",
  "home.opener.ivNone": "The interview's time is not written down yet.",
  "home.opener.offers": "We can go through the offers here: how they compare, what to negotiate, whether to accept. I will not interpret contract terms.",
  "home.opener.done": "The search is over. To start again, press the switch in settings.",
  "home.stats.k": "Statistics",
  "home.stats.close": "Hide ▴",
  "home.stats.open": "Show ▾",
  "home.today.region": "Today's picks",
  "home.today.k": "Today · %1",
  "home.today.title": "%1 high matches today",
  "home.today.left": "%1 still to look at, %2 already answered. The mid and low matches are under “See all of today's recommendations”.",
  "home.today.leftOnly": "%1 still to look at. The mid and low matches are under “See all of today's recommendations”.",
  "home.today.none": "No new high matches today yet. The mid and low matches are under “See all of today's recommendations”.",
  "home.today.unreadMay": "Not read closely by this search yet: %1 that may suit you.",
  "home.today.unreadUnlikely": "Not read closely by this search: %1 whose titles point elsewhere.",
  "home.today.unreadBoth": "Not read closely by this search yet: %1 that may suit you, and %2 whose titles point elsewhere.",
  "home.today.allAnswered": "You have answered all of today's high matches.",
  "home.today.batch": "Batch %1 of %2 · %3 each",
  "home.today.prev": "← Previous",
  "home.today.next": "Next →",
  "home.today.more": "%1 more on the Jobs page.",
  "home.today.answered": "Answered · %1",
  "home.today.unfold": "Show ▾",
  "home.asks.motion.first": "Which of today's is worth opening first?",
  "home.asks.motion.closest": "Which is closest to what I want to keep doing?",
  "home.asks.motion.week": "How does this week compare with last week?",
  "home.asks.iv.likely": "What is %1 most likely to ask?",
  "home.asks.iv.mock": "Run a mock interview with me",
  "home.asks.iv.week": "Do this week's interviews fit together?",
  "home.asks.offers.pay": "What should I watch for when negotiating?",
  "home.asks.offers.before": "What should I ask before accepting?",
  "home.ob.title": "A few words first",
  "home.ob.opener.resume": "Send me a résumé first — upload a PDF or a Word file, or paste your background. What I can infer goes straight onto the right; I only ask what I cannot.",
  "home.ob.opener.ask": "I only ask the %1 things I cannot infer. First: %2",
  "home.ob.ask.location_notes": "Where do you want to work, and how often would you go to an office?",
  "home.ob.ask.work_lang": "Which languages can you work in?",
  "home.ob.ask.direction": "What kind of role are you after? (backend, platform, ML, data …)",
  "home.ob.ask.salary_floor": "What is your yearly salary floor (gross, %1)?",
  "home.ob.mirror": "My profile",
  "home.ob.full": "Open the full page →",
  "home.ob.hint": "This only shows what the chat has already written. To change something, say it in the chat — or open My profile and edit that block.",
  "home.ob.report": "Market position report",
  "home.ob.need": "To generate it, I need:",
  "home.ob.resume": "Résumé",
  "home.ob.reportAfter": "Once these are in, I write the report in the chat.",
  "home.ob.reportFailed": "The last report did not get written. My profile says why.",
  "home.ob.reportWriting": "The report is being written. It opens under My profile when it is done.",
  "home.ob.reportReady": "The inputs are in. Say “write the report” in the chat.",
  "home.ob.reportDone": "Latest · %1 · open →",
  "home.ob.resumeNone": "Nothing yet. After you send one, roles and skills land here.",
  "home.ob.resumeMeta": "%1 · %2 roles · %3 degrees · %4 skills",
  "home.ob.upload": "Upload résumé",
  "home.ob.uploading": "Uploading…",
  "home.ob.tooBig": "Over 10MB",
  "home.ob.profile": "Profile",
  "home.ob.profileNone": "“Who you are” comes from the CV. Send one first.",
  "home.ob.hc": "Hard constraints and target",
  "home.ob.notAsked": "Not asked yet",
  "home.ob.said": "you said",
  "home.ob.resumeSrc": "from the CV",
  "home.ob.inferred": "inferred",
  "home.ob.q": "The few I could not infer",
  // the admin pages (block 5b)
  "admin.title": "Admin",
  "admin.nav.label": "Admin navigation",
  "admin.nav.runs": "Runs",
  "admin.nav.log": "Access",
  "admin.nav.models": "Models",
  "admin.nav.sources": "Sources",
  "admin.nav.render": "Render cache",
  "admin.nav.eval": "Matching",
  "admin.nav.spend": "Model spend",
  "admin.nav.payments": "Payments",
  "admin.spend.head": "Model spend",
  "admin.spend.lede": "Every paid model call is a row in the ledger (model_spend) the moment it is paid. Summed here per person and per day in their own time zone; open a cell for that day call by call. Ids, addresses, steps, models, dollars and tokens only — no text. Rows stay 90 days, then are archived a file a day to the archive bucket.",
  "admin.spend.cap": "Cap per person a day (budgets.user.day): %1",
  "admin.spend.capNone": "No cap per person a day (budgets.user.day)",
  "admin.spend.portalNot": "The portal's own calls (chat and the like) are not in it yet",
  "admin.spend.none": "Nothing in the ledger in the last 8 days.",
  "admin.spend.col.who": "Who",
  "admin.spend.market": "Everybody's (market, UTC days)",
  "admin.spend.ledger": "Ledger",
  "admin.spend.runs": "What the day's runs said",
  "admin.spend.reckonNote": "A run counts on the day it started: one that crossed midnight shows a difference on both days without a row missing.",
  "admin.spend.day": "%1 on %2: %3, %4 calls",
  "admin.spend.times": "Times in %1; the day is cut in the person's own time zone",
  "admin.spend.dayNone": "Nothing that day.",
  "admin.spend.col.at": "When",
  "admin.spend.col.run": "Run · step",
  "admin.spend.col.task": "Task",
  "admin.spend.col.model": "Model · backend",
  "admin.spend.col.usd": "Cost",
  "admin.spend.col.tokens": "Tokens in / out",
  "admin.payments.head": "Refused payments",
  "admin.payments.lede": "Stripe payments that were paid and that the function opening accounts (fulfil) refused: a price that is not the plan's, an account that is gone. One row each, the ones nobody has seen to first. The account's end date was not changed.",
  "admin.payments.none": "No refused payments.",
  "admin.payments.open": "Not seen to: %1",
  "admin.payments.col.at": "When",
  "admin.payments.col.who": "Account",
  "admin.payments.col.plan": "Plan",
  "admin.payments.col.amount": "Amount",
  "admin.payments.col.why": "Why",
  "admin.payments.col.session": "Checkout Session",
  "admin.payments.col.state": "State",
  "admin.payments.gone": "account gone",
  "admin.payments.deleting": "being deleted",
  "admin.payments.unresolved": "not seen to",
  "admin.payments.honoured": "honoured as well — nothing to do",
  "admin.payments.resolved": "seen to %1: %2",
  "admin.payments.capped": "The latest %1 only.",
  "admin.payments.how": "To see to one: add the time with python -m pipeline.cli grant, or refund it in Stripe's dashboard (the session opens the payment there); then python -m pipeline.cli payment-resolve <session> --note \"what was done\", and the notice on their billing page goes away.",
  "admin.nav.back": "← Back to the portal",
  "admin.whoDev": "Development: there is no door in front of this one, so whoever opens it is an admin.",
  "admin.runs.head": "Runs",
  "admin.runs.lede": "Fetching, judging, translating, research, and whatever a page asked for — what each segment did, how far it got, what it cost. Anything queued and not taken, or no longer breathing, comes first.",
  "admin.runs.none": "Nothing recorded yet. The next scheduled run writes the first row.",
  "admin.runs.waiting": "%1 queued and not taken yet",
  "admin.runs.waitingNote": "Written by the portal, waiting for the pipeline's drain to take them. All of them old means no drain is running.",
  "admin.runs.stalled": "%1 stopped breathing",
  "admin.runs.unlikely": "The unlikely title grade holds postings worth showing: %1 of %2 sampled in the last %3 days",
  "admin.runs.unlikelyNote": "95% interval %1–%2, its lower bound above %3. Scheduled searches do not read that grade but for a sample; consider rates.judge.read_unlikely 1. The ops check of %4.",
  "admin.runs.stalledNote": "Their state still says running, but nothing has moved the heartbeat for over %1 minutes. The ops segment only writes the stuck state after three hours; until then this line is the only thing that says so.",
  "admin.runs.clock": "Timed jobs",
  "admin.runs.clockWoke": "The clock last woke %1",
  "admin.runs.clockNever": "No drain has woken yet: nothing is queueing the timed jobs.",
  "admin.runs.clockAsleep": "The clock has not woken for %1 min: nothing is queueing the timed jobs.",
  "admin.runs.clockAsleepNote": "The resident drain queues every timed job (there is no crontab). Past %1 minutes without waking, it has stopped or hung: look at its systemd unit, or run cli schedule on the box.",
  "admin.runs.clockZones": "zones: %1",
  "admin.runs.clockNext": "next %1",
  "admin.runs.clockLast": "last %1 · %2",
  "admin.runs.clockNotYet": "not due yet",
  "admin.runs.notes": "Morning notes of %1, %2",
  "admin.runs.nights": "Nights of %1, %2",
  "admin.runs.runs": "Recent runs",
  "admin.runs.capped": "The most recent %1 runs.",
  "admin.log.capped": "The %1 most recently seen addresses, of %2.",
  "admin.runs.silent": "silent %1 min",
  "admin.runs.took": "took %1",
  "admin.runs.steps": "Steps",
  "admin.runs.col.state": "State",
  "admin.runs.col.did": "Done",
  "admin.runs.col.cost": "Cost",
  "admin.runs.col.took": "Took · note",
  "admin.runs.market": "market",
  "admin.runs.open": "open",
  "admin.runs.close": "close",
  "admin.runs.gate": "the gate refused %1 pieces of model output",
  "admin.state.running": "running",
  "admin.state.ready": "done",
  "admin.state.partial": "partial",
  "admin.state.failed": "failed",
  "admin.state.stuck": "stuck",
  "admin.step.running": "running",
  "admin.step.ok": "ok",
  "admin.step.partial": "partial",
  "admin.step.skipped": "skipped",
  "admin.step.failed": "failed",
  "admin.log.head": "Access log",
  "admin.log.lede": "Who has been here, where from, how often. One visit is a run of requests with no gap longer than %1 minutes.",
  "admin.log.none": "Nothing recorded yet. The next page anyone opens writes the first row.",
  "admin.log.ip": "IP address",
  "admin.log.place": "Location",
  "admin.log.device": "Device",
  "admin.log.first": "First seen",
  "admin.log.last": "Last seen",
  "admin.log.n": "Visits",
  "admin.log.total": "%1 addresses, %2 visits, %3 requests",
  "admin.log.local": "this machine",
  "admin.log.unknown": "unknown",
  "admin.log.zone": "Times in %1",
  "admin.log.theirTime": "read in %1 time",
  "admin.log.myTime": "read in my time",
  "admin.log.visits": "%1 visits",
  "admin.log.requests": "%1 requests",
  "admin.log.entry": "entered at",
  "admin.log.from": "from",
  "admin.log.lang": "language",
  "admin.log.signedIn": "signed in as %1",
  "admin.log.gone": "No record of that address.",
  "admin.log.visit": "This visit",
  "admin.log.backToIp": "← %1",
  "admin.log.backToAll": "← All addresses",
  "admin.dev.mobile": "phone",
  "admin.dev.tablet": "tablet",
  "admin.dev.desktop": "desktop",
  "admin.dev.bot": "bot",
  "admin.dev.unknown": "unknown",
  "admin.models.head": "Models",
  "admin.models.lede": "Which model does which job, as it stands right now. Edit models.json or the machine's override and the next call uses it, without a restart. This page only reads.",
  "admin.models.task": "Task",
  "admin.models.model": "Model",
  "admin.models.source": "From",
  "admin.models.price": "Price per million",
  "admin.models.ceiling": "Reply ceiling",
  "admin.models.backend": "Served by",
  "admin.models.why": "Why",
  "admin.models.src.env": "environment",
  "admin.models.src.local": "this machine",
  "admin.models.src.repo": "repository",
  "admin.models.files": "Repository %1",
  "admin.models.localHere": "Machine override %1 (present)",
  "admin.models.localGone": "Machine override %1 (absent)",
  "admin.models.prices": "Prices checked %1",
  "admin.models.broken": "models.json will not load: %1",
  "admin.models.noPrice": "no price",
  "admin.src.head": "Sources",
  "admin.src.lede": "The openings come from these boards. One row is one company's board on one system; “wanted” is how many users' source lists asked for it at the last crawl — each crawl works the lists out again first — and zero means that crawl walked past it.",
  "admin.src.none": "No boards match.",
  "admin.src.search": "Search boards and companies",
  "admin.src.board": "Board",
  "admin.src.company": "Company",
  "admin.src.origin": "How",
  "admin.src.read": "Last read",
  "admin.src.count": "Last count",
  "admin.src.open": "Open",
  "admin.src.chosen": "Wanted",
  "admin.src.never": "never read",
  "admin.src.totals": "%1 boards · %2 open postings · %3 users have chosen sources",
  "admin.src.unwanted": "%1 wanted by nobody",
  "admin.src.unread": "%1 never read",
  "admin.src.dormant": "dormant since %1",
  "admin.src.failing": "failed %1× in a row since %2",
  "admin.src.partial": "read in part since %1",
  "admin.src.partialN": "%1 read in part (closing nothing on their word: their postings close on their own pages meanwhile)",
  "admin.src.dormantN": "%1 dormant (not answering: no longer holds its company's postings open; still read nightly, wakes when it answers)",
  "admin.src.noChoosers": "No user has run select_sources yet, so “wanted” is zero everywhere and the nightly run reads all of them.",
  "admin.src.agg": "Shared feeds",
  "admin.src.aggNone": "No aggregator site has been found yet. The night's sweep looks for one in each country somebody searches in.",
  "admin.src.sort.read": "last read",
  "admin.src.sort.open": "open postings",
  "admin.src.sort.board": "name",
  "admin.src.sort.chosen": "wanted",
  "admin.src.sortBy": "Sort",
  "admin.src.origin.registry": "registry",
  "admin.src.origin.lead": "lead",
  "admin.src.origin.discover": "discovered",
  "admin.src.origin.paste": "pasted",
  "admin.src.origin.seed": "seeded",
  "admin.src.clear": "clear",
  "admin.render.head": "Render cache",
  "admin.render.lede": "Model-written text on the site is read from this cache in the reader's interface language; what is missing the portal queues and the render segment writes. Only counts, contracts, languages, engines and failure reasons here — never a source or a rendering.",
  "admin.render.window": "Last 7 days = from %1, in %2 time",
  "admin.render.stale": "%1 claimed over %2 minutes ago and never finished",
  "admin.render.staleNote": "Still marked running: the run that claimed them crashed or timed out. The portal queues them again the next time they are on screen (unless their attempts are used up), with the attempt already counted; if this keeps showing, the render segment keeps failing.",
  "admin.render.cache": "Cache",
  "admin.render.cacheNone": "Nothing cached yet.",
  "admin.render.engines": "Engine: legacy is an old translation copied in by render-backfill, same is a source already in the target language (free), anything else is the model that wrote it. Characters are the source's.",
  "admin.render.col.contract": "Contract",
  "admin.render.col.lang": "Into",
  "admin.render.col.engine": "Engine",
  "admin.render.col.week": "Last 7 days",
  "admin.render.col.all": "All time",
  "admin.render.col.rows": "Rows",
  "admin.render.col.chars": "Characters",
  "admin.render.col.cost": "Cost",
  "admin.render.col.day": "Day",
  "admin.render.col.state": "State",
  "admin.render.col.now": "Now",
  "admin.render.col.asked": "Asked, last 7 days",
  "admin.render.col.reason": "Reason",
  "admin.render.col.n": "Count",
  "admin.render.col.last": "Last",
  "admin.render.total": "Total",
  "admin.render.days": "Written per day",
  "admin.render.requests": "Waiting requests",
  "admin.render.requestsNone": "Nothing queued, running or failed.",
  "admin.render.state.queued": "queued",
  "admin.render.state.running": "running",
  "admin.render.state.failed": "failed",
  "admin.render.state.refused": "refused",
  "admin.render.oldest": "The longest in the queue since %1, waiting %2 min",
  "admin.render.givenUp": "%1 tried %2 times and no longer retried",
  "admin.render.failures": "Why they failed (top 10)",
  "admin.render.failuresNone": "No failed requests.",
  "admin.render.masked": "Reasons are shown by kind only: no figure, link or text they quote appears; one no kind matches counts as “other”.",
  "admin.render.gate": "Gate refusals (last 7 days)",
  "admin.render.gateNone": "The gate refused no render output in the last 7 days.",
  // the matching report (#929)
  "admin.eval.head": "Matching against decisions",
  "admin.eval.lede": "How far the judge's showing, scoring, banding and order agree with what people actually decided. Worked out again for a person each time they have handled enough postings; everyone's is the sum of each person's newest.",
  "admin.eval.threshold": "Threshold: a report every %1 postings handled",
  "admin.eval.swept": "Last checked %1",
  "admin.eval.neverSwept": "Not checked yet",
  "admin.eval.caveats": "What the numbers can and cannot say",
  "admin.eval.caveat.exposure": "Exposure: people can only decide on what was put in front of them. Rates are over postings the judge showed and they handled; one never handled is not counted, and not counted as a no.",
  "admin.eval.caveat.newest": "The answer is the decision in force (the newest one); an undo back to nothing leaves the posting unhandled.",
  "admin.eval.caveat.rejudged": "Only the newest judgement is kept: one judged again after the decision counts on its new verdict (how many is shown below).",
  "admin.eval.caveat.score": "The score uses their weights as they are today and the posting's age on the day of the decision; the bands use the cut points in force as this page is read.",
  "admin.eval.caveat.rank": "Order: where the posting stood in what the judge read the night it was judged (rank_grade, kept since 0109); judged earlier counts as “no record”.",
  "admin.eval.overall": "Everyone",
  "admin.eval.none": "No report yet. The first is written at the next check after someone has handled %1 postings.",
  "admin.eval.personHead": "Report for %1",
  "admin.eval.personNone": "No report for this person yet.",
  "admin.eval.personClose": "Close",
  "admin.eval.people": "People",
  "admin.eval.peopleNone": "Nobody has decided anything yet.",
  "admin.eval.col.user": "Person",
  "admin.eval.col.fresh": "Handled since last / threshold",
  "admin.eval.col.lastReport": "Last report",
  "admin.eval.col.lastDecision": "Last decision",
  "admin.eval.never": "None yet",
  "admin.eval.history": "History",
  "admin.eval.historyNone": "Nothing worked out yet.",
  "admin.eval.col.at": "When",
  "admin.eval.col.whose": "Whose",
  "admin.eval.col.trigger": "Trigger",
  "admin.eval.col.upto": "Up to decision",
  "admin.eval.everyone": "Everyone",
  "admin.eval.trigger.auto": "Automatic (threshold)",
  "admin.eval.trigger.manual": "By hand (command line)",
  "admin.eval.col.positive": "Went for",
  "admin.eval.col.maybe": "Kept",
  "admin.eval.col.passed": "Passed",
  "admin.eval.oldShape": "The report of %1 is in an older shape; the next one replaces it.",
  "admin.eval.counted": "Worked out %1: %2 postings handled, %3 people",
  "admin.eval.notes": "of the shown, %1 judged again after the decision, %2 given a band by hand",
  "admin.eval.col.what": "Postings",
  "admin.eval.shown": "Shown (the rates are over these)",
  "admin.eval.hidden": "Not shown by the judge (went for = the judge missed it)",
  "admin.eval.unjudged": "No judgement (brought in by hand, or the posting retired)",
  "admin.eval.byBand": "By band (cut points high %1 / mid %2)",
  "admin.eval.col.band": "Band",
  "admin.eval.col.rate": "Went for (95% interval)",
  "admin.eval.col.kept": "Went for or kept (95% interval)",
  "admin.eval.curve": "By score (twentieths)",
  "admin.eval.col.score": "Score",
  "admin.eval.rank": "By the night's title grade and place in the order",
  "admin.eval.col.grade": "Title grade",
  "admin.eval.grade.likely": "likely",
  "admin.eval.grade.maybe": "maybe",
  "admin.eval.grade.unlikely": "unlikely",
  "admin.eval.grade.none": "No grade (read as maybe)",
  "admin.eval.grade.absent": "No record",
  "admin.eval.col.place": "Place",
  "admin.eval.firstK": "Share in the first %1",
  "admin.eval.reasons": "Reasons given for passing (shown postings)",
  "admin.eval.reasonsNone": "No reasons given yet.",
  "admin.eval.col.reason": "Reason",
  "admin.eval.col.total": "Times",
  "admin.eval.custom": "Their own reasons",
  // ---- sign in / sign up / the free week (block 6): the door is this
  // application's own now, not the Google one that used to stand in front
  "auth.signIn": "Sign in",
  "auth.signUp": "Sign up",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.forgot": "Forgot password",
  "auth.other": "Sign in with another account",
  "auth.google": "Continue with Google",
  "auth.noAccount": "No account yet?",
  "auth.toSignUp": "Sign up →",
  "auth.haveAccount": "Already have an account?",
  "auth.toSignIn": "Sign in →",
  "auth.signOut": "Sign out",
  "auth.signedOut": "You are signed out.",
  "auth.working": "One moment…",
  "auth.signOutFailed": "Could not sign out. Please try again.",
  // the 503 page the proxy answers with when it cannot look up a session (Issue 260)
  "unavailable.title": "Service temporarily unavailable",
  "unavailable.body": "Refresh the page in a moment. You will not need to sign in again.",
  "unavailable.retry": "Refresh",
  // the six-digit code
  "auth.code.head": "Check your mail",
  "auth.code.sent": "A 6-digit code is on its way to %1. It is good for %2 minutes.",
  "auth.code.label": "Code",
  "auth.code.submit": "Verify and continue",
  "auth.code.resend": "Send it again",
  "auth.code.resendIn": "You can ask again in %1s",
  "auth.code.another": "Use a different address",
  "auth.code.devNote": "This machine has no mail account configured; the code is printed on the server console.",
  // what can go wrong. %1 is a number of minutes, or the tries left
  "auth.err.email": "Give an address you can read mail at.",
  "auth.err.password": "A password of at least 10 characters.",
  "auth.err.credentials": "That address and password do not go together.",
  "auth.err.locked": "Too many attempts. Try again in %1 minutes.",
  "auth.err.code": "That code is not right. %1 tries left.",
  "auth.err.codeGone": "That code has expired or been used. Ask for a new one.",
  "auth.err.tooMany": "That is a lot of mail in a short time. Try again shortly.",
  "auth.err.tooManyWait": "That is a lot of mail in a short time. Try again in %1s.",
  "auth.err.mail": "The mail did not go out. Try again in a moment.",
  "auth.err.failed": "That did not go through. Try again in a moment.",
  "auth.err.google": "That did not go through with Google. Try again, or sign in with an address and password.",
  "auth.err.session": "You were signed out. Sign in again.",
  // The two letters, which go to a mailbox rather than to a page — in the
  // language the page was in. %1 the code, %2 the minutes it lasts
  "auth.mail.code.subject": "Your Counting AI verification code",
  "auth.mail.code.body": "Code: %1\n\nType it on the page you left open. It is good for %2 minutes.\nIf this was not you, ignore this letter; nothing has happened.",
  "account.email.oneOnly": "Your login email is also your only notification email. The new address must be verified first; afterward the old one is no longer used.",
  "account.email.new": "New email",
  "account.email.send": "Verify new email",
  "account.email.code": "Verification code",
  "account.email.verify": "Confirm change",
  "account.email.cancel": "Cancel",
  "account.email.sent": "A code was sent to the new email. Your current email stays unchanged until verification succeeds.",
  "account.email.taken": "That email already belongs to another account. Sign in with it or recover that account.",
  "account.email.same": "That is already the current login email.",
  "account.email.wrong": "That code is not correct. Try again.",
  "account.email.rate": "Please wait before sending another verification code.",
  "account.email.failed": "The email was not changed. The code may have expired; send a new one.",
  "account.email.mailSubject": "Verify your new Counting AI email",
  "account.email.mailBody": "Code: %1\n\nEnter it in Counting AI settings within %2 minutes. The old email stays current until verification succeeds. If this was not you, ignore this message.",
  "auth.mail.exists.subject": "This address already has a Counting AI account",
  "auth.mail.exists.body": "Somebody just tried to sign up with this address, and it already has an account, so nothing was created.\n\nIf that was you: sign in on the sign-in page, or use \"forgot password\" if that is the problem.\nIf it was not: ignore this letter. Nothing about your account has changed.",
  "auth.mail.none.subject": "There is no Counting AI account for this address",
  "auth.mail.none.body": "Somebody just asked to reset a Counting AI password for this address, and there is no account on it, so nothing was changed.\n\nIf that was you: the sign-up page is where to start.\nIf it was not: ignore this letter.",
  "auth.err.taken": "That address already has an account — sign in instead.",
  // resetting a password
  "auth.reset.head": "Reset your password",
  "auth.reset.lede": "Give your address and we will send a code to it.",
  "auth.reset.new": "New password",
  "auth.reset.submit": "Set this password",
  "auth.reset.sent": "If that address has an account, a code is on its way to it.",
  "auth.reset.done": "The password is changed, and every other device has been signed out.",
  // the free week and what follows it (§21)
  "billing.head": "Subscription",
  "billing.active": "Your subscription is running.",
  "billing.trialLeft": "%1 days left of the trial",
  "billing.trialLeftOne": "1 day left of the trial",
  "billing.trialEndsOn": "Trial runs until %1",
  "billing.expired": "The free week is over.",
  "billing.lede": "Your data is still there and you can take it with you. To carry on, or to have the account and its data deleted, write to us.",
  "billing.lede.paid": "The subscription is running; there is nothing to do. The button below is here whenever you want your data out; to have the account and its data deleted, write to us.",
  "billing.contact": "Write to us to open it up →",
  "billing.write": "Write to us →",
  "billing.export": "Export my data",
  "billing.signedInAs": "Signed in as %1",
  "billing.back": "Back to the portal",
  "billing.plan.month.name": "1 month",
  "billing.plan.quarter.name": "3 months",
  "billing.plan.year.name": "12 months",
  "billing.plan.month.item": "Prospect · 1 month",
  "billing.plan.quarter.item": "Prospect · 3 months",
  "billing.plan.year.item": "Prospect · 12 months",
  "billing.perMonth": "%1 a month",
  "billing.off": "Save %1%",
  "billing.buy": "Buy",
  "billing.renew": "Renew",
  "billing.subscribe": "Subscribe",
  "billing.opening": "Opening the payment page…",
  "billing.methods": "%1",
  "billing.method.apple_pay": "Apple Pay",
  "billing.method.google_pay": "Google Pay",
  "billing.method.alipay": "Alipay",
  "billing.method.wechat_pay": "WeChat Pay",
  "billing.once": "One payment; nothing renews by itself.",
  "billing.lede.buy": "Pick how long, and it opens up as soon as you have paid. Your data is all still there.",
  "billing.lede.early": "Buying now does not waste the rest of the trial: it starts from the day the trial ends.",
  "billing.lede.renew": "Renewing adds on from your current end date.",
  "billing.lede.delete": "To have the account and its data deleted, write to us.",
  "billing.paidUntil": "Paid up until %1",
  "billing.success.head": "Payment received",
  "billing.success.until": "%1 added — you're set until %2.",
  "billing.success.see": "See your subscription",
  "billing.pending": "This payment is not confirmed yet. If you have paid, give it a moment and refresh this page.",
  "billing.refused": "We received a payment from you but could not open your account with it automatically. A person will see to it soon — the time added, or the money refunded.",
  "billing.refusedWrite": "We received a payment from you but could not open your account with it automatically. A person will see to it soon — the time added, or the money refunded. Questions: write to %1.",
  "billing.err.off": "Paying online is not available yet; write to us to open the account.",
  "billing.err.stripe": "Could not open the payment page. Please try again later.",
  "billing.err.failed": "Could not open the payment page. Check your connection and try again.",
  // A button pressed on a push, on any transport (press.*, #626); Slack's own lines and the modal behind the ones that need words (slack.*, #256).
  "press.chose": "Chosen: %1",
  "press.failed": "That did not go through; answer it on the site.",
  "press.answered": "This question has already been answered.",
  "press.decision.new": "undecided",
  "press.decision.same": "This opening is already “%1”.",
  "press.decision.change": "This opening is currently “%1”. Change it to “%2”?",
  "press.decision.changed": "Changed from “%1” to “%2”.",
  "slack.decision.moved": "This opening changed to “%1” while the box was open. Use the message again to change it.",
  "press.trialOver": "Your free week is over; see the site.",
  "press.moved": "This opening has just changed to “%1” elsewhere. Press again to change it.",
  "press.reasons": "Why not? Pick any reasons, or none; to say more, press “Write a reason”. Then press “Submit”.",
  "press.submitFor": "Submit · %1",
  "press.note": "Write a reason",
  "press.noteAsk": "Reply to this message: why is “%1” not for you?",
  "press.notePlaceholder": "Why it is not for you",
  "press.noteSaved": "Noted. Once the reasons are picked, press “%1”.",
  "press.noteLate.submitted": "That opening was already submitted; this reason was not recorded.",
  "press.noteLate.cancelled": "Those reasons were cancelled; this reason was not recorded.",
  "press.noteLost": "Your reason was not recorded: this opening was already decided elsewhere.",
  "press.cancel": "Cancel",
  // A Telegram morning's three answers, a third of a phone's row each (#765): shorter than the card's own (card.goApply …).
  "press.pick.preparing": "Apply",
  "press.pick.maybe": "Save",
  "press.pick.passed": "Pass",
  "press.changeTo": "Change to “%1”",
  "press.onSite": "This one is answered on the site.",
  "press.open": "Open",
  "slack.modal.change": "Change choice",
  "slack.modal.changeSubmit": "Update",
  "slack.modal.answer": "Answer",
  "slack.modal.when": "Another time",
  "slack.modal.what": "Put it differently",
  "slack.modal.answerLabel": "Your answer",
  "slack.modal.currencyLabel": "Currency",
  "slack.modal.whenLabel": "When works",
  "slack.modal.whatLabel": "How it should read",
  "slack.modal.submit": "Send",
  "slack.modal.close": "Cancel",
  "slack.modal.empty": "Nothing written yet.",
  "press.salaryUnread": "Couldn't read that: write one yearly floor, like 70k or 70000 GBP.",
  "slack.modal.why": "Not for me",
  "slack.modal.reasonsLabel": "What doesn't fit (optional)",
  "slack.modal.whyLabel": "One line so I can learn (optional)",
  "slack.noModal": "The box could not be opened just now; please answer on the site.",
  "slack.noReason": "Saved as ‘Not for me’; I couldn't ask for a reason.",
  "slack.notRewritten": "Saved, but I couldn't update the message above, so its buttons may still be there.",
  "slack.openSite": "Open the site",
  // Connect Slack, and what a slack row is sent (#256, PR2).
  "me.set.ch.slackLede": "Pushes arrive as Slack DMs with buttons to answer them; connecting is one authorisation on Slack's side.",
  "me.set.ch.connectSlack": "Connect Slack",
  "me.set.ch.slackUnavailable": "This deployment has no Slack app configured; nothing to connect to yet.",
  "me.set.ch.slack.connected": "Connected. A DM should have arrived in Slack.",
  "me.set.ch.slack.err.oauth": "Slack did not hand over a token; not connected. Try again.",
  "me.set.ch.slack.err.state": "That authorisation was not started from this browser; not connected. Press 'Connect Slack' again.",
  "me.set.ch.slack.err.client": "This deployment has no Slack app configured.",
  "me.set.ch.slack.err.exists": "This account already has a Slack; to switch, remove the current one first.",
  "me.set.sub.title": "What is sent here",
  "me.set.sub.today": "Today's new openings",
  "me.set.sub.interviews": "Interview preparation ready",
  "me.set.sub.asks": "Things to answer",
  "me.set.sub.reports": "Reports and leads",
  "me.set.sub.account": "Account and trial",
  "slack.connected": "Connected. New openings, questions for you, reports and leads, and interview preparation will arrive here, with buttons to answer them.",
  "privacy.choice.off": "This site does not record anything in your browser at the moment, so you are not asked.",
  "me.set.analytics.browserOff": "What your browser records: not switched on for this site.",
  // #788 PR2: the question, the privacy page, the settings card, the error page.
  "consent.title": "Help us make this better?",
  "consent.body": "If you agree, your browser notes which pages you open here, how long you stay, which controls you use and where something goes wrong. Nothing you write, no employer or job you look at, and not your name or email address is noted. Saying no changes nothing about what you can do.",
  "consent.change": "You can change this any time under My profile → Settings → Usage statistics.",
  "consent.more": "Details",
  "consent.yes": "Agree",
  "consent.no": "Don't agree",
  "privacy.title": "Privacy and usage statistics",
  "privacy.lede": "What we record to improve the product, what we never record, and how you choose.",
  "privacy.server.h": "What our server records",
  "privacy.server.p": "When you do something here — answer an onboarding step, save a setting, send a message — the server notes which kind of action it was, whether it worked and how long it took; for background work (reading your CV, the first search, a report) how long it took and whether it worked. These are requests you send us anyway, so no separate consent is asked; you can turn it off under My profile → Settings.",
  "privacy.browser.h": "What your browser records",
  "privacy.browser.p": "Only once you agree: which pages you open (the kind of page, such as \"a job's page\", never which one), how long each was in front of you, which controls you use, and where something went wrong on the screen.",
  "privacy.never.h": "Never in the usage statistics",
  "privacy.never.p": "Anything you write, your CV, which employer or job you look at, a page's actual address, your IP address and your browser's details. The records carry no name, email address or account id — only a code computed from your account.",
  "privacy.where.h": "Where it is kept, and for how long",
  "privacy.where.p": "Records are written in batches to our own file storage — not the database, and never to advertisers. Once an analytics platform is connected, they are deleted from our storage as soon as it has imported them; in our storage they are kept for at most 730 days.",
  "privacy.source.h": "Where you came from",
  "privacy.source.p": "If you first arrive through a link carrying campaign tags, or from another website, we keep that website's name, the tags and the kind of page you landed on in a cookie for 30 days; if you sign up, they are stored with your account and the cookie is removed. Never the address of the page that sent you.",
  "privacy.choice.h": "Your choice",
  "privacy.choice.granted": "This browser now: agreed to the browser's record.",
  "privacy.choice.denied": "This browser now: did not agree to the browser's record.",
  "privacy.choice.none": "This browser has not chosen yet.",
  "privacy.choice.server": "The server's record is turned off under My profile → Settings.",
  "me.set.analytics.title": "Usage statistics",
  "me.set.analytics.lede": "So we can see how this is used, what is slow and what breaks, and improve it. Nothing you write, no employer or job you look at, and not your name is recorded.",
  "me.set.analytics.server": "What our server records",
  "me.set.analytics.what.server": "Which kind of action you took, whether it worked, how long it took. Off: nothing more of this is recorded for you.",
  "me.set.analytics.browser": "What this browser records",
  "me.set.analytics.what.browser": "Pages opened, time on them, controls used, what went wrong. Applies to this browser only.",
  "me.set.analytics.more": "Details",
  "error.title": "Something went wrong on this page",
  "error.body": "The page could not be shown. Try reloading it.",
  "error.retry": "Reload",
};
